import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiMenu, FiChevronRight, FiPlus, FiList, FiX } from "react-icons/fi"; // Import hamburger and right-chevron icon
import { Outlet } from "react-router-dom";
import { FaBell, FaUser } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa6";
import { MdOutlinePayment } from "react-icons/md";
import { IoBook } from "react-icons/io5";
import { SiXero } from "react-icons/si";
import { HiEye } from "react-icons/hi2";
import { MdEmail, MdSms, MdLabel } from "react-icons/md";
import { BsFileCodeFill } from "react-icons/bs";
import { IoIosSettings } from "react-icons/io";
import { FaCode } from "react-icons/fa";
import { IoIosRefreshCircle } from "react-icons/io";
import { MdMarkEmailUnread } from "react-icons/md";
import appointmentGif from "../assets/appointment.gif";
import serviceGif from "../assets/service.gif";
import scheduleGif from "../assets/schedule.gif";
import staffGif from "../assets/staff.gif";
import crmGif from "../assets/crm.gif";
import paymentGif from "../assets/payment.gif";
import exportGif from "../assets/export.gif";
import settingsGif from "../assets/settings.gif";
import embedGif from "../assets/embeded.gif";
import { FaEdit } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { TbTooltip } from "react-icons/tb";
import { BiSolidEdit } from "react-icons/bi";
import { CgFormatJustify } from "react-icons/cg";
import { BaseUrl } from "../App";
import { RiSeoLine } from "react-icons/ri";
import axios from "axios";
import { useAuth } from '../components/AuthContext';

const AdminPanel = () => {
  const sidebarRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const { logout } = useAuth()
  const navigate = useNavigate(); // Initialize navigate hook
  const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar starts as hidden
  const [notificationSidebarVisible, setNotificationSidebarVisible] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [notifications, setNotifications] = useState([]); // State for notifications
  const [userdata, setuserdata] = useState([]); // State for notifications
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [showSelected, setShowSelected] = useState(false);
  const [residential, setResidential] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const [officeresidential, setofficeResidential] = useState(false);
  const [officecommercial, officesetCommercial] = useState(false);
  console.log(userdata);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [adminData, setAdminData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [Detailsiud, setDetailsiud] = useState(null); // Set default to
  const [detailsdata, setDetailsdata] = useState({});
  const [order_id_appointment, setorder_id_appointment] = useState(0);
  const [showEditServiceModal, setShowEditServiceModal] = useState(false);
  const [userSelectedMethods, setUserSelectedMethods] = useState(null);
  const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
  const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] = useState(null);
  const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [userSelectedAddon, setUserSelectedAddon] = useState(null);
  const [services, setServices] = useState([]);
  const [bookingappointment, setbookingappointment] = useState([]);
  const [isBookingComplete, setIsBookingComplete] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [Detailsiuddata, setDetailsiuddata] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
  const [notes, setNotes] = useState("");
  const [rescheduledData, setRescheduledData] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [Settings, setSettings] = useState(false);
  console.log(Settings.ct_company_name, "Settings");
  const [submenuVisible, setSubmenuVisible] = useState({
    appointment: false,
    service: false,
    schedule: false,
    staff: false,
    crm: false,
    payment: false,
    export: false,
    embeded: false,
    setting: false,
  }); // State for submenu visibility
  const handleRescheduleClick = (id) => {
    setShowRescheduleModal(true);
    setDetailsiuddata(id);
  };

  // Example:  Accessing the sidebar's DOM node
  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setSidebarVisible(false);
    }
  };

  const fetchSettings = async () => {
  
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/settings.php`,
        {
          action: "get_all_settings",
          api_key: "1",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.data.status === "true" && response.data.statuscode === 200) {
        const fetchedSettings = response.data.response.reduce((acc, item) => {
          if (item.option_name === "ct_company_logo") {
            acc[item.option_name] = item.postalcode; // Store postal codes as a comma-separated string
          } else {
            acc[item.option_name] = item.option_value;
          }
          return acc;
        }, {});
        console.log(fetchedSettings )
  
        setSettings((prevSettings) => ({
          ...prevSettings,
          ...fetchedSettings,
        }));  
      } else {
        throw new Error(response.data.response || "Failed to fetch settings");
      }
    } catch (error) {
      setError(error.message);
    } 
  };
  // Call fetchSettings on component mount
  useEffect(() => {
    // const interval = setInterval(() => {
      fetchSettings();
    // }, 1000); // 1000ms = 1 second
  
    // return () => clearInterval(interval); // Cleanup on component unmount
  }, []);
  
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handaldeleted = async (id) => {
    try {
      // Define the request payload
      const payload = {
        action: "delete_booking", // Action to fetch all services
        api_key: 1,
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Delete Appointment Booking Successfully!");
        const services = response.data;
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
 getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };
  const handleRejectClick = () => {
    setShowForm(!showForm); // Toggle form visibility
  };

  const closeRescheduleModal = () => {
    // Changed name here
    setShowRescheduleModal(false);
  };
  const handleUpdate = async (e, rescheduleDate) => {
    e.preventDefault();

    // Validate the rescheduleDate
    if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
      alert("Invalid date. Please provide a valid date.");
      return;
    }

    // Format the reschedule date into a readable format
    const formattedDate = new Date(rescheduleDate)
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    // Data to save

    const [date, time] = formattedDate.split(" "); // Split into date and time

    // Log data to the console (optional)
    console.log("Rescheduled Data:", date, time, Detailsiuddata, notes);

    try {
      // Define the request payload
      const payload = {
        action: "reschedule_appointment", // Fixed value to identify the action
        api_key: 1, // Your system's API key for authentication
        order_id: Detailsiuddata, // The ID of the appointment to reschedule
        notes: notes, // Any notes about the reschedule
        date: date, // New date (YYYY-MM-DD format)
        time: time, // New time (HH:mm format)
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reshedule.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Reschedule Appointment Booking Successfully!");
        const services = response.data;
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      setRescheduledData(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    }

    // Save the data into state (without displaying it on the page)

    // Optionally, handle additional actions (like resetting the form or other states)
    closeRescheduleModal();
  };
  const handleReject = async (id, e) => {
    e.preventDefault();
    console.log("Reject Reason:", rejectReason, id);
    // Add your logic here to handle the reject reason
    try {
      // Define the request payload
      const payload = {
        action: "reject_appointment", // Action to fetch all services
        api_key: 1,
        order_id: id,
        reject_reason: rejectReason,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reject.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Reject Appointment Booking Successfully!");
        const services = response.data;
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    }

    setShowForm(false); // Close the form after submission
  };

  const handalapointment_complete = async (id) => {
    console.log(id, "DADSA");
    try {
      // Define the request payload
      const payload = {
        action: "complete_appointment", // Action to fetch all services
        api_key: "1",
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_complete.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Appointment Booking Completed Successfully!");
        const services = response.data;
        console.log(services);
        setIsBookingComplete(true);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      // filteredBookings() 
      getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handalconfirm_appointment = async (id) => {
    console.log(id, "DADSA");
    try {
      // Define the request payload
      const payload = {
        action: "confirm_appointment", // Action to fetch all services
        api_key: "1",
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_confirm.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Appointment Booking Confirmed Successfully!");
        const services = response.data;
        console.log(services);
        setIsBookingComplete(true);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const deleteallbooking = async (id) => {
    try {
      // Define the request payload
      const payload = {
        action: "delete_recurring_booking", // Action to fetch all services
        recurring_id: id,
        api_key: "1", // API key for authentication
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Delete All Appointment Booking Successfully!");
        const services = response.data;
        console.log(services);
        // setDetailsdata(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
    getappointmentdetails();
    bookeddata();
    handleCloseModal();
  };

  useEffect(() => {
    // Send a GET request to your PHP API
    axios
      .get(`${BaseUrl}/backend/api/services.php?action=getadmin`)
      .then((response) => {
        if (response.data.status === "true") {
          console.log(response.data.data);
          setAdminData(response.data.data);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((err) => {
        console.log("An error occurred while fetching data");
      });
  }, []);

  const getuser = async () => {
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php?getusers`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded", // Use form-urlencoded
          },
        }
      );

      console.log(response);

      if (response.data.data) {
        console.log("API Response:", response.data.data);
        setuserdata(response.data.data);
      } else {
        console.log("API response is empty.");
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getuser();
  }, []);

  const getappointmentdetails = async () => {
    try {
      // Define the request payload
      const payload = {
        action: "getbookingdetails", // Action to fetch all services
        order_id: Detailsiud, // API key for authentication
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        const services = response.data;
getdata();
bookeddata();
        setDetailsdata(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getappointmentdetails();
  }, [Detailsiud]);

  const getdata = async () => {
    try {
      const payload = new URLSearchParams();
      payload.append("getallnotificationdata", "1"); // Match the PHP expected key

      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        {
          action: "getallbookings",
          api_key: "1",
          start_date: "1900-01-01",  // Very old date to include everything
          end_date: "9999-12-31"     // Very future date to include everything
      }
     

      );

      console.log(response?.data?.response);

      if (response?.data) {
        console.log("API Response:", response?.data?.response);
        setNotifications(response?.data?.response);
      } else {
        console.log("API response is empty.");
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getdata();
  }, []);

  const filteredBookings = (Array.isArray(notifications) ? notifications : []).filter((booking) => {
    const bookingDate = new Date(booking?.booking_date_time);
    const currentDate = new Date();
    const threeMonthsLater = new Date();
    threeMonthsLater.setMonth(currentDate.getMonth() + 3);
  
    return bookingDate >= currentDate && bookingDate <= threeMonthsLater;
  }).map((booking) => {
    const client = userdata.find((user) => user.id === booking?.client_id);
    return {
      ...booking,
      clientName: client
        ? `${client.first_name} ${client.last_name}`
        : booking.client_id,
    };
  }).filter((booking) =>
    booking.clientName.toLowerCase().includes(searchTerm.toLowerCase())
  ).sort(
    (a, b) => new Date(a.booking_date_time) - new Date(b.booking_date_time)
  );

  const bookeddata = async () => {
    try {
      const currentDate = new Date(); // Current date
      // Format the date in YYYY-MM-DD format
      const formattedDate = currentDate.toISOString().split("T")[0];
      // Convert formattedDate back to Date object to extract year and month
      const currentDateObj = new Date(formattedDate);
      // Get the first day of the current month
      const start_date = new Date(
        currentDateObj.getFullYear(),
        currentDateObj.getMonth(),
        1
      )
        .toISOString()
        .split("T")[0];

      // Get the last day of the month, 3 months from now
      const end_date = new Date(
        currentDateObj.getFullYear(),
        currentDateObj.getMonth() + 3 + 1,
        0
      )
        .toISOString()
        .split("T")[0];

      // Define the request payload
      const payload = {
        action: "getallbookings", // Action to fetch all services
        api_key: "1", // API key for authentication
        start_date: start_date,
        end_date: end_date,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );
      console.log(response);

      // Check if the response contains valid data
      if (response.data && response.data.status === "true") {
        const services = response.data;
        console.log(services.response);

        if (Array.isArray(services.response)) {
          console.log("Fetched Data:", services); // Log the fetched data
          setbookingappointment(services.response);
          // setTableData(services); // Uncomment to update the table
        } else {
          console.log("No valid array in response data:", response.data);
        }
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handleEditClick = async () => {
    setShowSelected(!showSelected);
    try {
      // Define the request payload
      const payload = {
        action: "staff_assign_to_booking", // Action to fetch all services
        api_key: 1,
        order_id: detailsdata.id,
        staff_ids: selectedStaff,
      };

      console.log(payload);

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/staff_assign.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data) {
        setSuccessMessage("Assign Booking To Staff successfully!");

        console.log("API Response:", response.data);
        const services = response.data;
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }

      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handleSelectChange = (event) => {
    const selectedId = event.target.value; // Extract values
    setSelectedStaff(selectedId); // Update state
  };
    useEffect(() => {
      if (detailsdata?.staff_ids && detailsdata.staff_ids.length > 0) {
        setSelectedStaff(detailsdata.staff_ids);
      }
    }, [detailsdata?.staff_ids]);

  const openEditServiceModal = async (id) => {
    setorder_id_appointment(detailsdata.id);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        {
          action: "get_edit_booking_info",
          api_key: "1",
          order_id: detailsdata.id,
        }
      );

      if (response.data.status === "true") {
        setSuccessMessage("Edit Booking Successfully!");

        // Assuming the response structure is as you provided
        const bookingData = response.data.response.ct_cart.method;
        console.log(response.data);

        setSelectedAppointment(bookingData); // Store the booking data in state
        setShowEditServiceModal(true);
        const serviceIds = response.data.response.ct_cart.method.map(
          (item) => item.service_id
        );
        const methodIds = response.data.response.ct_cart.method.map(
          (item) => item.method_id
        );
        const unitsIds = response.data.response.ct_cart.method.map(
          (item) => item.units_id
        );
        const s_m_qty = response.data.response.ct_cart.method.map(
          (item) => item.s_m_qty
        );
        const addonIds = response.data.response.ct_cart.method
          .filter((item) => item.type === "addon")
          .map((item) => item.units_id); // Capture the `units_id` for addons.

        setUserSelectedMethods(serviceIds); // Output: ['19', '19']
        setUserSelectedMethodsId(methodIds); // Output: ['19', '19']
        setUserSelectedMethodsUnitsId(unitsIds);
        setUserSelectedMethodsSmqty(s_m_qty);
        setUserSelectedAddon(addonIds);

        let data = services
          .filter(
            (id) =>
              Array.isArray(serviceIds) && serviceIds.includes(id.service_id)
          )
          .map((md) => {
            // Add filtering based on method_id
            return md.methods
              .filter((meData) => methodIds.includes(meData.method_id))
              .map((filteredMethod) => {
                console.log(filteredMethod);
                return filteredMethod; // This will keep the filtered data
              });
          });
        let allData = services.map((service) => {
          return service.methods.map((method) => {
            const filteredAddons = method.addons.filter((addon) =>
              addonIds.includes(addon.addon_id)
            );
            // Map through methods and filter relevant addons
            return {
              ...method,
              addons: filteredAddons, // Include only the selected addons
            };
          });
        });
        console.log("Selected Addons: ", addonIds);
        console.log(
          "Response Addons: ",
          response.data.response.ct_cart.method.filter(
            (item) => item.type === "addon"
          )
        );
        console.log("------------------------------", allData);
        // console.log("----------------------", units_id);
        console.log("---------------------------------------------", s_m_qty);
        console.log(
          "---------------------------------------------",
          data[0][0]
        );
        // console.log("---------------------------------------------", data[0][0][0]);
        handleMethodSelection(data[0][0], data[0][0].method_id);
        console.log("Selected Units: ", unitsIds);
        console.log("Method Data: ", data[0][0]);
        handleMethodSelection(data[0][0], data[0][0].method_id);
       
      } else {
        console.error(
          "Error fetching booking details:",
          response.data.response
        );
      }
    } catch (error) {
      console.error("Error fetching booking details:", error);
    }
  };
  const handleNavigation = (path) => {
    navigate(path);
    setSidebarVisible(false); // Close sidebar after navigation
  };

  // Toggle Sidebar visibility
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  // Toggle Notification Sidebar visibility
  const toggleNotificationSidebar = () => {
    setNotificationSidebarVisible(!notificationSidebarVisible);
  };

  // Toggle submenu visibility for each section
  const toggleSubmenu = (section) => {
    setSubmenuVisible((prevState) => {
      const newState = {
        appointment: false,
        service: false,
        schedule: false,
        staff: false,
        crm: false,
        payment: false,
        export: false,
        embeded: false,
        setting: false,
      };
      newState[section] = !prevState[section];
      return newState;
    });
  };

  const handleProfileClick = () => {
    navigate("/admin/adminProfile");
    setSidebarVisible(false);
  };
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };
  const handleLogoutConfirm = () => {
    setShowLogoutModal(false);
    logout();
    navigate("/login");
    setSidebarVisible(false);
  };
  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };
  const handleShowModal = (event) => {
    console.log(event);
    setSelectedEvent(event);
    setDetailsiud(event.order_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleMethodSelection = (method, id) => {
    switch ((method.method_title, id)) {
      case "Residential Services":
        setResidential(true);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Commercial Services":
        setResidential(false);
        setCommercial(true);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Property Based":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(true);
        officesetCommercial(false);
        break;
      case "Area Based (Feet)":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(true);
        break;
      default:
        // Reset all states if no match is found
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
    }

    setSelectedMethod(method, id);
  };


  const admindb = () => {
    navigate("/admin");
    setSidebarVisible(false);
  };
  return (
    <>
     {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative ">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
   <div className="flex min-h-screen">
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`${
          sidebarVisible ? "block" : "hidden"
        } fixed top-0 left-0 w-64 h-full bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 rounded-lg z-50 transition-all duration-300`}
        style={{ maxHeight: "100vh", overflowY: "auto" }}
      >
        <button
          onClick={() => setSidebarVisible(false)}
          className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
        >
          <FiX />
        </button>
        <h2
          className="text-2xl font-medium text-center mb-8 cursor-pointer hover:text-blue-500"
          onClick={admindb}
        >
          MegaClean
        </h2>
        <ul>
          {/* Appointment Section */}
          <li className="mb-1">
            {/* <button
              onClick={() => handleNavigation("/admin/appointment")} // Direct navigation for items without submenu
              className="flex items-center justify-between w-full text-black  rounded-lg p-2 transition-all duration-300"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              style={{
                backgroundColor: 
                   Settings?.ct_secondary_color_admin || "#000000"
                  
              }}
            >
              <div className="flex items-center space-x-4">
                <img
                  src={appointmentGif}
                  alt="Appointment"
                  className="w-12 h-12 object-contain transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg font-medium hover:text-white">
                  Appointment
                </span>
              </div>
            </button> */}
            <button
            onClick={() => handleNavigation("/admin/appointment")}
         
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300  hover:bg-blue-400"
           
          >
            <div className="flex items-center space-x-4">
              <img
                src={appointmentGif}
                alt="Appointment"
                className="w-12 h-12 object-contain transition-all duration-300 transform hover:scale-110 hover:bg-blue-400"
              />
              <span className="text-lg font-medium hover:text-white">
                Appointment
              </span>
            </div>
          </button>

          </li>

          {/* Service */}
          <li className="mb-1">
          <button
            onClick={() => handleNavigation("/admin/service")}
           
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300 hover:bg-blue-400"
          
          >
              <div className="flex items-center space-x-4">
                <img
                  src={serviceGif}
                  alt="Service"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg font-medium hover:text-white">
                  Service
                </span>
              </div>
            </button>
          </li>

          {/* Schedule */}
          <li className="mb-1">
          <button
            onClick={() => handleNavigation("/admin/schedule")}
            
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300  hover:bg-blue-400"
          
          >
              <div className="flex items-center space-x-4">
                <img
                  src={scheduleGif}
                  alt="Schedule"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg font-medium hover:text-white">
                  Schedule
                </span>
              </div>
            </button>
          </li>

          {/* Staff with Submenu */}
          <li className="mb-1">
          <button
            onClick={() =>  toggleSubmenu("staff")}
            
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300  hover:bg-blue-400"
          
          >
              <div className="flex items-center space-x-4">
                <img
                  src={staffGif}
                  alt="Staff"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg font-medium hover:text-white">
                  Staff
                </span>
              </div>
              <FiChevronRight
                className={`transition-transform duration-300 transform ${
                  submenuVisible.staff ? "rotate-90" : "rotate-0"
                }`}
              />
            </button>
            {submenuVisible.staff && (
              <ul className="pl-8">
                 <li>
                 <button
                    onClick={() => handleNavigation("/admin/staff/")}
                    
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full  "
                  
                  >
                    <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                     Add Staff 
                    </span>
                  </button>
                </li>
                <li>
                <button
                    onClick={() =>  handleNavigation("/admin/staff/addStaff")}
                    
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full "
                   
                  >
                    <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Staff Details
                    </span>
                  </button>
                </li>
                <li>
                <button
                    onClick={() => handleNavigation("/admin/staff/staffPayment")}
                  
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                  
                  >
                    <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Staff Payment Details
                    </span>
                  </button>
                </li>
              </ul>
            )}
          </li>

          {/* CRM */}
          <li className="mb-1">
          <button
            onClick={() => handleNavigation("/admin/crm")}
           
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300  hover:bg-blue-400"
          
          >
              <div className="flex items-center space-x-4">
                <img
                  src={crmGif}
                  alt="CRM"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg font-medium hover:text-white">
                  CRM
                </span>
              </div>
            </button>
          </li>

          {/* Payment with Submenu */}
          <li className="mb-1">
          <button
            onClick={() => toggleSubmenu("payment")}
            
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300  hover:bg-blue-400"
           
          >
              <div className="flex items-center space-x-4">
                <img
                  src={paymentGif}
                  alt="Payment"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg font-medium hover:text-white">
                  Payment
                </span>
              </div>
              <FiChevronRight
                className={`transition-transform duration-300 transform ${
                  submenuVisible.payment ? "rotate-90" : "rotate-0"
                }`}
              />
            </button>
            {submenuVisible.payment && (
              <ul className="pl-8">
                 <li>
                 <button
                    onClick={() => handleNavigation("/admin/payment")}
                  
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                  
                  >
                    <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                     Client Payment Detail
                    </span>
                  </button>
                </li>
                <li>
                <button
                    onClick={() => handleNavigation("/admin/payment/staffPaymentDetails")}
                    
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                   
                  >
                    <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Staff Payment Details
                    </span>
                  </button>
                </li>
                <li>
                <button
                    onClick={() => handleNavigation("/admin/payment/recurrenceDetail")}
                   
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                   
                  >
                    <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Recurrence Details
                    </span>
                  </button>
                </li>
              </ul>
            )}
          </li>

          {/* Export with Submenu */}
          <li className="mb-1">
          <button
            onClick={() =>  toggleSubmenu("export")}
         
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300 hover:bg-blue-400"
           
          >
              <div className="flex items-center space-x-4">
                <img
                  src={exportGif}
                  alt="Export"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110 "
                />
                <span className="text-lg font-medium hover:text-white">
                  Export
                </span>
              </div>
              <FiChevronRight
                className={`transition-transform duration-300 transform ${
                  submenuVisible.export ? "rotate-90" : "rotate-0"
                }`}
              />
            </button>
            {submenuVisible.export && (
              <ul className="pl-8">
                 <li>
                 <button
                    onClick={() =>  handleNavigation("/admin/export")}
                    
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                    
                  >
                    <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Booking Information
                    </span>
                  </button>
                </li>
                <li>
                <button
                    onClick={() => handleNavigation("/admin/export/customerInformation")}
               
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                   
                  >
                    <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Customer Information
                    </span>
                  </button>
                </li>
                <li>
                <button
                    onClick={() => handleNavigation("/admin/export/serviceInformation")}
                    
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                   
                  >
                    <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
                    <span className="text-left font-bold hover:text-white">
                      Service Information
                    </span>
                  </button>
                </li>
              </ul>
            )}
          </li>

          {/* Embed Code */}
          <li className="mb-1">
          <button
                    onClick={() =>  handleNavigation("/admin/embeded")}
                
                    className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
                    
                  >
              <div className="flex items-center space-x-4">
                <img
                  src={embedGif}
                  alt="Embeded"
                  className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                />
                <span className="text-lg text-black font-medium hover:text-white">
                  Embed Code
                </span>
              </div>
            </button>
          </li>

          {/* Settings with Submenu */}
     
            <li className="mb-1 scrollbar-hide">
            <button
            onClick={() =>  toggleSubmenu("setting")}
          
            className="flex items-center justify-between w-full text-black rounded-lg p-2 transition-all duration-300  hover:bg-blue-400"
            
          >
                <div className="flex items-center space-x-4">
                  <img
                    src={settingsGif}
                    alt="Setting"
                    className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
                  />
                  <span className="text-lg font-medium text-ellipsis overflow-hidden whitespace-nowrap max-w-[calc(100%-3rem)]">
                    Setting
                  </span>
                </div>
                <FiChevronRight
                  className={`transition-transform duration-300 transform ${
                    submenuVisible.setting ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>
              {submenuVisible.setting && (
                <ul className="pl-4">
                  {[
                   {
                    path: "/admin/setting",
                    icon: <FaBuilding />,
                    label: "Company Details",
                  },
                    {
                      path: "/admin/setting/appearance",
                      icon: <HiEye />,
                      label: "Appearance",
                    },
                    {
                      path: "/admin/setting/genral",
                      icon: <IoIosSettings />,
                      label: "General",
                    },
                    {
                      path: "/admin/setting/recurrence",
                      icon: <IoIosRefreshCircle />,
                      label: "Recurrence",
                    },
                    {
                      path: "/admin/setting/emailTemplate",
                      icon: <MdMarkEmailUnread />,
                      label: "Email Template",
                    },  
                    {
                      path: "/admin/setting/promocode",
                      icon: <BsFileCodeFill />,
                      label: "Promocode",
                    },
                    {
                      path: "/admin/setting/payment",
                      icon: <MdOutlinePayment />,
                      label: "Payment",
                    },
                    // {
                    //   path: "/admin/setting/manageableForm",
                    //   icon: <CgFormatJustify />,
                    //   label: "Manageable Form Fields",
                    // },
                  
                    // {
                    //   path: "/admin/setting/smsTemplate",
                    //   icon: <MdSms />,
                    //   label: "SMS Template",
                    // },
                    // {
                    //   path: "/admin/setting/referral",
                    //   icon: <FaCode />,
                    //   label: "Referral",
                    // },
                    // {
                    //   path: "/admin/setting/seo",
                    //   icon: <RiSeoLine />,
                    //   label: "SEO",
                    // },
                    // {
                    //   path: "/admin/setting/emailNotification",
                    //   icon: <MdEmail />,
                    //   label: "Email Notification",
                    // },
                    // {
                    //   path: "/admin/setting/label",
                    //   icon: <MdLabel />,
                    //   label: "Labels",
                    // },
                   
                    // {
                    //   path: "/admin/setting/smsnotification",
                    //   icon: <MdSms />,
                    //   label: "SMS Notification",
                    // },
                 
                    // {
                    //   path: "/admin/setting/fronttooltip",
                    //   icon: <TbTooltip />,
                    //   label: "Front Tool Tips",
                    // },
                 
                   
                    // {
                    //   path: "/admin/setting/xero",
                    //   icon: <SiXero />,
                    //   label: "Xero",
                    // },
                  ].map(({ path, icon, label }) => (
                    <li key={path}>
                      <button
                        onClick={() => handleNavigation(path)}
                        className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full hover:text-white"
                      >
                        <div className="text-2xl text-gray-700 transition-all duration-300 transform hover:text-white rounded-md">
                          {icon}
                        </div>
                        <span className="text-left font-bold text-gray-700 transition-all duration-300 transform hover:text-white rounded-md">
                          {label}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
        </ul>
      </div>

      <div className="flex-1 flex flex-col relative">
        {/* <header className="bg-blue-800 text-white p-4 flex justify-between items-center"> */}
        <header
          style={{
            backgroundColor: Settings?.ct_primary_color_admin || "#0834e2",
            color: Settings?.ct_text_color_admin || "#ffffff",
          }}
          className="p-4 flex justify-between items-center"
        >

          <button onClick={toggleSidebar} 
             style={{color: Settings?.ct_text_color_admin || "#ffffff"}}
          className=" text-2xl">
            <FiMenu />
          </button>
          <h1
            onClick={() => navigate("/")}
            className="text-2xl font-medium   cursor-pointer"
          >
           {Settings.ct_company_name ? Settings.ct_company_name : "  My Booking Page"}
          </h1>
          <div className="flex items-center space-x-4">
          <button onClick={toggleNotificationSidebar}  style={{
  
            color: Settings?.ct_text_color_admin || "#ffffff",
          }}
          className="relative">
          <FaBell size={24} />
          {filteredBookings.filter(booking => booking.booking_status === "A" ||  booking.booking_status === "C").length > 0 && (
            <span 
         
            className="absolute -top-2 -right-2 bg-red-500  text-xs font-semibold rounded-full w-5 h-5 flex items-center justify-center">
              {filteredBookings.filter(booking => booking.booking_status === "A" ||  booking.booking_status === "C").length}
            </span>
          )}
        </button>
          <button onClick={handleProfileClick} 
             style={{color: Settings?.ct_text_color_admin || "#ffffff"}}>
            <FaUser size={24} />
          </button>
          <button onClick={handleLogoutClick}    style={{color: Settings?.ct_text_color_admin || "#ffffff"}}>
            <FaPowerOff size={24} />
          </button>
        </div>
        </header>

        {/* Logout Modal */}
        {showLogoutModal && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 sm:w-1/3 max-w-sm">
              <p className="text-lg font-medium text-gray-800 mb-4">
                Are you sure you want to log out?
              </p>
              <div className="flex justify-center space-x-4 mt-4">
                <button
                  onClick={handleLogoutConfirm}
                  className="px-4 py-2 bg-green-500 text-white rounded-md"
                >
                  Yes
                </button>
                <button
                  onClick={handleLogoutCancel}
                  className="px-4 py-2 bg-red-500 text-white rounded-md"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {showModal && detailsdata && (
          <div className="fixed inset-0 py-16 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 ">
            <div className="bg-white p-6 overflow-y-auto   h-[500px] rounded-lg w-full max-w-md sm:max-w-lg md:w-auto  lg:max-w-2xl xl:max-w-3xl min-[320px]:w-3/4 max-[640px]:w-3/4  overflow-auto">
              {/* Modal Header */}
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Booking Details</h2>
                <button
                  onClick={handleCloseModal}
                  className="text-gray-500 hover:text-gray-700 font-bold"
                >
                  X
                </button>
              </div>

              {/* Booking Info */}
              <div className="space-y-6">
                <div className="flex flex-col sm:flex-row justify-between items-center">
                  <span className="font-medium mb-3 ">Booking Status:</span>
                  <span className="text-green-500 mb-3">
                    {detailsdata.booking_status}
                  </span>
                  <button
                    // onClick={() => openEditServiceModal()}
                    // className="text-black flex items-center gap-2 p-2 border rounded-md hover:bg-blue-500 hover:text-white"
                  >
                    {/* <FaEdit /> Edit Booking Details */}
                  </button>
                </div>

                <div className="space-y-4">
                  <table>
                    <tr>
                      <td className="font-bold w-24">Booking Date </td>

                      <td>
                        {detailsdata?.appointment_starttime}
                        {detailsdata?.appointment_start_time}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-bold">Service</td>
                      <td>{detailsdata?.service_title}</td>
                    </tr>
                    <tr>
                      <td className="font-bold">Methods</td>
                      <td>{detailsdata?.method_title}</td>
                    </tr>
                    <tr>
                      <td className="font-bold">Units</td>
                      <td>{detailsdata?.unit_title}</td>
                    </tr>{" "}
                    <tr>
                      <td className="font-bold">Addons</td>
                      <td>{detailsdata?.addons_title}</td>
                    </tr>{" "}
                    <tr>
                      <td className="font-bold">Price</td>
                      <td>{detailsdata?.booking_price}</td>
                    </tr>{" "}
                    <tr>
                      <td className="font-bold">Duration</td>
                      <td>{detailsdata?.booking_duration}</td>
                    </tr>
                  </table>
                </div>
                <div className="flex justify-between">
                  <h2 className="text-xl font-bold">Customer Detail</h2>
                  <Link to={`editCustomer/${selectedEvent.client_id}`}>
                    <button className="text-blue-500 mt-2 sm:mt-0">
                      <span className="text-2xl">{/* <BiSolidEdit /> */}</span>
                    </button>
                  </Link>
                </div>

                {/* Customer Information */}
                <div className="space-y-4">
                  <table>
                    <tr>
                      <td className="font-bold w-20">Name</td>
                      <td>{detailsdata?.client_name}</td>
                    </tr>
                    <tr>
                      <td className="font-bold ">Email </td>
                      <td>{detailsdata?.client_email}</td>
                    </tr>
                    <tr>
                      <td className="font-bold ">Phone:</td>
                      <td>{detailsdata?.client_phone}</td>
                    </tr>
                    <tr>
                      <td className="font-bold ">Notes:</td>
                      <td>{detailsdata?.client_notes}</td>
                    </tr>
                    <tr>
                      <td className="font-bold">Address:</td>
                      <td>
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            detailsdata?.client_address
                          )}`}
                          target="_blank"
                          style={{ color: "blue" }}
                          rel="noopener noreferrer"
                        >
                          {detailsdata?.client_address}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td className="font-bold ">Payment:</td>
                      <td>{detailsdata?.payment_type}</td>
                    </tr>
                  </table>
                </div>
                {/* Assign Appointment */}
                {/* <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                  <div className="flex items-center w-full sm:w-auto">
                    <span className="mr-2">Assign Appointment to Staff:</span>
                    <select
                      className="border p-2 rounded-md w-full sm:w-auto"
                      value={selectedStaff || ""}
                      onChange={handleSelectChange}
                    >
                      <option value="">Nothing selected</option>
                      {adminData && adminData.length > 0 ? (
                        adminData.map((staff, index) => (
                          <option key={index} value={staff.id}>
                            {staff.fullname}
                          </option>
                        ))
                      ) : (
                        <option value="">No staff available</option>
                      )}
                    </select>
                  </div>

                  <div className="mt-2 sm:mt-0 sm:ml-4">
                    <button className="text-blue-500" onClick={handleEditClick}>
                      <span className="text-2xl">
                        <BiSolidEdit />
                      </span>
                    </button>
                  </div>
                </div> */}
                  <div className="flex-col sm:flex-row justify-between items-center mt-4">
                                      <div className="flex items-center sm:w-auto">
                                        <div className="border p-2 rounded-md bg-white w-full shadow-md space-y-2  max-h-72 overflow-y-auto">
                                          <div className="p-2 text-gray-700 font-medium">Assign Appointment to Staff:</div>
                                          {adminData?.length > 0 ? (
                                            <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 p-2">
                                              {adminData.map((staff) => (
                                                <div
                                                  key={staff.id}
                                                  className="flex items-center space-x-3 hover:bg-gray-100 p-1 rounded"
                                                >
                                                  <input
                                                    type="checkbox"
                                                    value={staff?.id}
                                                    checked={selectedStaff.includes(staff?.id)}
                                                    onChange={(e) => {
                                                      const id = e?.target?.value;
                                                      setSelectedStaff((prev) =>
                                                        e?.target?.checked
                                                          ? [...prev, id]
                                                          : prev?.filter((staffId) => staffId !== id)
                                                      );
                                                    }}
                                                    className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500"
                                                  />
                                                  <span className="text-gray-800">{staff.fullname}</span>
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <p className="text-gray-500 text-center">No staff available</p>
                                          )}
                                           <div className="mt-2 flex justify-end ">
                                        <button className="text-blue-500 bg-gray-200 border border-gray-400 rounded-md p-1 hover:bg-gray-300 transition-colors"  onClick={handleEditClick}>
                                          <span className="text-2xl">
                                            <BiSolidEdit />
                                          </span>
                                        </button>
                                      </div>
                                        </div>
                                      </div>
                                  </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
                {detailsdata.booking_status === "R" && (
                  <>
                    <button
                      type="button"
                      onClick={() => handaldeleted(detailsdata.id)}
                      className="text-red-500 font-semiboldpx-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      ✖ Delete
                    </button>

                    <button
                      type="button"
                      onClick={() => deleteallbooking(detailsdata.recurring_id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      🗑️ Delete All Recurring
                    </button>
                  </>
                )}

                {detailsdata.booking_status === "A" && (
                  <>
                    <button
                      type="button"
                      onClick={() => handalconfirm_appointment(detailsdata.id)}
                      className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                    >
                      ✔ confirm
                    </button>

                    <button
                      type="button"
                      onClick={() => handleRescheduleClick(detailsdata.id)}
                      className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                    >
                      ↻ Reschedule
                    </button>

                    <button
                      type="button"
                      onClick={handleRejectClick}
                      className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      👎🏻 Reject
                    </button>

                    {/* Reschedule Modal */}
                    {detailsdata && showRescheduleModal && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        <div className="bg-white p-6 rounded-md shadow-lg w-96">
                          <h2 className="text-lg font-semibold mb-4">
                            Reschedule Appointment
                          </h2>
                          {/* Amount Input */}
                          <div className="mb-4">
                            <label
                              htmlFor="amount"
                              className="block text-gray-700 mb-2"
                            >
                              Amount:
                            </label>
                            <input
                              type="number"
                              id="amount"
                              value={
                                detailsdata?.booking_price
                                  ? detailsdata.booking_price.replace(
                                      /[^0-9.-]+/g,
                                      ""
                                    )
                                  : ""
                              }
                              className="w-full px-3 py-2 border rounded-md"
                            />
                          </div>

                          {/* Date Picker (Calendar) */}
                          <div className="mb-4">
                            <label
                              htmlFor="date"
                              className="block text-gray-700 mb-2"
                            >
                              Select Date:
                            </label>
                            <input
                              type="datetime-local"
                              id="date"
                              value={rescheduleDate}
                              onChange={(e) =>
                                setRescheduleDate(e.target.value)
                              }
                              className="w-full px-3 py-2 border rounded-md"
                            />
                          </div>

                          {/* Notes Input */}
                          <div className="mb-4">
                            <label
                              htmlFor="notes"
                              className="block text-gray-700 mb-2"
                            >
                              Notes:
                            </label>
                            <textarea
                              id="notes"
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                              className="w-full px-3 py-2 border rounded-md"
                              placeholder="Add any notes"
                            />
                          </div>

                          {/* Action Buttons */}
                          <div className="flex justify-end gap-4">
                            <button
                              type="button"
                              onClick={closeRescheduleModal}
                              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              onClick={(e) => handleUpdate(e, rescheduleDate)}
                              className="bg-blue-500 text-white px-4 py-2 rounded-md"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Reject Form */}
                    {showForm && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        <form
                          onSubmit={(e) => handleReject(detailsdata.id, e)}
                          className="bg-white p-6 rounded-md shadow-lg w-96"
                        >
                          <h2 className="text-lg font-semibold mb-4">
                            Enter Reject Reason
                          </h2>
                          <label
                            htmlFor="rejectReason"
                            className="block text-gray-700 mb-2"
                          >
                            Reason:
                          </label>
                          <input
                            type="text"
                            id="rejectReason"
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md mb-4"
                            placeholder="Reason for rejection"
                          />
                          <div className="flex justify-end gap-4">
                            <button
                              type="button"
                              onClick={() => setShowForm(false)}
                              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="bg-red-500 text-white px-4 py-2 rounded-md"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={() => handaldeleted(detailsdata.id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      ✖ Delete
                    </button>

                    <button
                      type="button"
                      onClick={() => deleteallbooking(detailsdata.recurring_id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      🗑️ Delete All Recurring
                    </button>
                  </>
                )}

                {detailsdata.booking_status === "C" && (
                  <>
                    <button
                      type="button"
                      onClick={() => handalapointment_complete(detailsdata.id)}
                      className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                    >
                      ✔ Complete
                    </button>

                    <button
                      type="button"
                      onClick={() => handaldeleted(detailsdata.id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      ✖ Delete
                    </button>

                    <button
                      type="button"
                      onClick={() => deleteallbooking(detailsdata.recurring_id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      🗑️ Delete All Recurring
                    </button>
                  </>
                )}
                {detailsdata.booking_status === "RS" && (
                  <>
                    <button
                      type="button"
                      onClick={() => handalapointment_complete(detailsdata.id)}
                      className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                    >
                      👍 Complete
                    </button>

                    <button
                      type="button"
                      onClick={() => handleRescheduleClick(detailsdata.id)}
                      className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                    >
                      ↻ Reschedule
                    </button>

                    <button
                      type="button"
                      onClick={handleRejectClick}
                      className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      👎🏻 Reject
                    </button>

                    {/* Reschedule Modal */}
                    {detailsdata && showRescheduleModal && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        <div className="bg-white p-6 rounded-md shadow-lg w-96">
                          <h2 className="text-lg font-semibold mb-4">
                            Reschedule Appointment
                          </h2>
                          {/* Amount Input */}
                          <div className="mb-4">
                            <label
                              htmlFor="amount"
                              className="block text-gray-700 mb-2"
                            >
                              Amount:
                            </label>
                            <input
                              type="number"
                              id="amount"
                              value={
                                detailsdata?.booking_price
                                  ? detailsdata.booking_price.replace(
                                      /[^0-9.-]+/g,
                                      ""
                                    )
                                  : ""
                              }
                              className="w-full px-3 py-2 border rounded-md"
                            />
                          </div>

                          {/* Date Picker (Calendar) */}
                          <div className="mb-4">
                            <label
                              htmlFor="date"
                              className="block text-gray-700 mb-2"
                            >
                              Select Date:
                            </label>
                            <input
                              type="datetime-local"
                              id="date"
                              value={rescheduleDate}
                              onChange={(e) =>
                                setRescheduleDate(e.target.value)
                              }
                              className="w-full px-3 py-2 border rounded-md"
                            />
                          </div>

                          {/* Notes Input */}
                          <div className="mb-4">
                            <label
                              htmlFor="notes"
                              className="block text-gray-700 mb-2"
                            >
                              Notes:
                            </label>
                            <textarea
                              id="notes"
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                              className="w-full px-3 py-2 border rounded-md"
                              placeholder="Add any notes"
                            />
                          </div>

                          {/* Action Buttons */}
                          <div className="flex justify-end gap-4">
                            <button
                              type="button"
                              onClick={closeRescheduleModal}
                              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              onClick={(e) => handleUpdate(e, rescheduleDate)}
                              className="bg-blue-500 text-white px-4 py-2 rounded-md"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Reject Form */}
                    {showForm && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        <form
                          onSubmit={(e) => handleReject(detailsdata.id, e)}
                          className="bg-white p-6 rounded-md shadow-lg w-96"
                        >
                          <h2 className="text-lg font-semibold mb-4">
                            Enter Reject Reason
                          </h2>
                          <label
                            htmlFor="rejectReason"
                            className="block text-gray-700 mb-2"
                          >
                            Reason:
                          </label>
                          <input
                            type="text"
                            id="rejectReason"
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md mb-4"
                            placeholder="Reason for rejection"
                          />
                          <div className="flex justify-end gap-4">
                            <button
                              type="button"
                              onClick={() => setShowForm(false)}
                              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="bg-red-500 text-white px-4 py-2 rounded-md"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={() => handaldeleted(detailsdata.id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      ✖ Delete
                    </button>

                    <button
                      type="button"
                      onClick={() => deleteallbooking(detailsdata.recurring_id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      🗑️ Delete All Recurring
                    </button>
                  </>
                )}

                {detailsdata.booking_status === "CO" && (
                  <>
                    <div className="text-gray-500">
                      This Appointment Is Completed
                    </div>

                    <button
                      type="button"
                      onClick={() => handaldeleted(detailsdata.id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      ✖ Delete
                    </button>

                    <button
                      type="button"
                      onClick={() => deleteallbooking(detailsdata.recurring_id)}
                      className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                    >
                      🗑️ Delete All Recurring
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Sidebar */}
        {notificationSidebarVisible && (
          <div
            ref={sidebarRef}
            className="fixed top-0 right-0 w-80 bg-white text-black p-6 shadow-lg border-l-4 border-blue-800 z-50 transition-all duration-300 max-h-screen overflow-y-auto"
          >
            {/* Close Button */}
            <button
              onClick={() => setNotificationSidebarVisible(false)}
              className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
            >
              <FiX />
            </button>

            {/* Sidebar Title */}
            <h2 className="text-2xl font-medium mb-4">Booking Information</h2>
           
            {/* Search Input */}
            <input
              type="text"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-md focus:shadow-lg transition-shadow"
            />

            {/* Filtered Booking List */}
            {filteredBookings.length > 0 ? (
  filteredBookings
    .filter(
      (booking) =>
        booking.booking_status === "A" || booking.booking_status === "C"
    ) // Only show A and C statuses
    .map((booking, index) => {
      const bookingDate = new Date(booking.booking_date_time);
      const today = new Date();

      // Normalize today's date (remove time for accurate comparison)
      today.setHours(0, 0, 0, 0);
      bookingDate.setHours(0, 0, 0, 0);

      const timeDiff = bookingDate - today;
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      // Calculate remaining time (days or months)
      let timeText;
      if (daysDiff === 0) {
        timeText = "Today";
      } else if (daysDiff >= 30) {
        const months = Math.floor(daysDiff / 30); // Only full months
        timeText = `${months} ${months > 1 ? "months" : "month"}`;
      } else {
        timeText = `${daysDiff} ${daysDiff > 1 ? "days" : "day"}`;
      }

      // Status mapping
      const statusLabels = {
        A: "Active",
        C: "Confirm",
        R: "Rejected",
        CC: "Customer Cancelled",
        CS: "Customer Service",
        CO: "Completed",
        MC: "Manager Confirmed",
        RS: "Rescheduled",
      };

      // Function to remove notification for Active status
      const handleActiveClick = (bookingId) => {
        if (booking.booking_status === "A") {
          setNotifications((prevNotifications) =>
            prevNotifications.filter(
              (notification) => notification.order_id !== bookingId
            )
          );
        }
        handleShowModal(booking); // Still open the modal
      };

      return (
        <div
          key={index}
          className="mb-4 p-4 border rounded-lg shadow-md bg-gray-100 transition-all duration-300 transform hover:shadow-xl hover:scale-[1.02]"
        >
          <p className="text-lg text-gray-700">
            {booking.clientName} for {booking.title} on{" "}
            <strong>{booking.booking_date_time}</strong>
          </p>

          {/* Show remaining or late days in proper format */}
          <p
            className={`font-medium ${
              daysDiff < 0 ? "text-red-500" : "text-blue-500"
            }`}
          >
            {daysDiff < 0
              ? `${Math.abs(daysDiff)} days late`
              : `${timeText} remaining`}
          </p>

          <button
            className={`px-4 py-2 rounded-lg transition-all duration-300 transform hover:scale-110 ${
              booking.booking_status === "A"
                ? "bg-green-500 text-white"
                : booking.booking_status === "C"
                ? "bg-red-500 text-white"
                : "bg-yellow-500 text-white"
                }`}
                onClick={() => handleActiveClick(booking.order_id)}
              >
                {statusLabels[booking.booking_status] || "Unknown"}
              </button>
            </div>
                  );
                })
            ) : (
              <p className="text-gray-500">No bookings found</p>
            )}
          </div>
        )}
        {/* Content Section */}
        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
    </>
  );
};

export default AdminPanel;



// import React, { useState, useRef, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FiMenu, FiChevronRight, FiPlus, FiList, FiX } from "react-icons/fi"; // Import hamburger and right-chevron icon
// import { Outlet } from "react-router-dom";
// import { FaBell, FaUser } from "react-icons/fa";
// import { FaPowerOff } from "react-icons/fa6";
// import { MdOutlinePayment } from "react-icons/md";
// import { IoBook } from "react-icons/io5";
// import { SiXero } from "react-icons/si";
// import { HiEye } from "react-icons/hi2";
// import { MdEmail, MdSms, MdLabel } from "react-icons/md";
// import { BsFileCodeFill } from "react-icons/bs";
// import { IoIosSettings } from "react-icons/io";
// import { FaCode } from "react-icons/fa";
// import { IoIosRefreshCircle } from "react-icons/io";
// import { MdMarkEmailUnread } from "react-icons/md";
// import appointmentGif from "../assets/appointment.gif";
// import serviceGif from "../assets/service.gif";
// import scheduleGif from "../assets/schedule.gif";
// import staffGif from "../assets/staff.gif";
// import crmGif from "../assets/crm.gif";
// import paymentGif from "../assets/payment.gif";
// import exportGif from "../assets/export.gif";
// import settingsGif from "../assets/settings.gif";
// import embedGif from "../assets/embeded.gif";
// import { FaEdit } from "react-icons/fa";
// import { TbTooltip } from "react-icons/tb";
// import { BiSolidEdit } from "react-icons/bi";
// import { CgFormatJustify } from "react-icons/cg";
// import { BaseUrl } from "../App";
// import { RiSeoLine } from "react-icons/ri";
// import axios from "axios";
// import { useAuth } from '../components/AuthContext';

// const AdminPanel = () => {
//   const sidebarRef = useRef(null);
  
//   const { logout } = useAuth()
//   const navigate = useNavigate(); // Initialize navigate hook
//   const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar starts as hidden
//   const [notificationSidebarVisible, setNotificationSidebarVisible] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [notifications, setNotifications] = useState([]); // State for notifications
//   const [userdata, setuserdata] = useState([]); // State for notifications
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [selectedStaff, setSelectedStaff] = useState([]);
//   const [showSelected, setShowSelected] = useState(false);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   console.log(userdata);
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [adminData, setAdminData] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [Detailsiud, setDetailsiud] = useState(null); // Set default to
//   const [detailsdata, setDetailsdata] = useState({});
//   const [order_id_appointment, setorder_id_appointment] = useState(0);
//   const [showEditServiceModal, setShowEditServiceModal] = useState(false);
//   const [userSelectedMethods, setUserSelectedMethods] = useState(null);
//   const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
//   const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] = useState(null);
//   const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] = useState(null);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [userSelectedAddon, setUserSelectedAddon] = useState(null);
//   const [services, setServices] = useState([]);
//   const [bookingappointment, setbookingappointment] = useState([]);
//   const [isBookingComplete, setIsBookingComplete] = useState(false);
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [Detailsiuddata, setDetailsiuddata] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
//   const [notes, setNotes] = useState("");
//   const [rescheduledData, setRescheduledData] = useState(null);
//   const [rejectReason, setRejectReason] = useState("");
//   const [submenuVisible, setSubmenuVisible] = useState({
//     appointment: false,
//     service: false,
//     schedule: false,
//     staff: false,
//     crm: false,
//     payment: false,
//     export: false,
//     embeded: false,
//     setting: false,
//   }); // State for submenu visibility
//   const handleRescheduleClick = (id) => {
//     setShowRescheduleModal(true);
//     setDetailsiuddata(id);
//   };

//   // Example:  Accessing the sidebar's DOM node
//   const handleClickOutside = (event) => {
//     if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//       // Click was outside the sidebar
//       setSidebarVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handaldeleted = async (id) => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Delete Appointment Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//  getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };
//   const handleRejectClick = () => {
//     setShowForm(!showForm); // Toggle form visibility
//   };

//   const closeRescheduleModal = () => {
//     // Changed name here
//     setShowRescheduleModal(false);
//   };
//   const handleUpdate = async (e, rescheduleDate) => {
//     e.preventDefault();

//     // Validate the rescheduleDate
//     if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
//       alert("Invalid date. Please provide a valid date.");
//       return;
//     }

//     // Format the reschedule date into a readable format
//     const formattedDate = new Date(rescheduleDate)
//       .toISOString()
//       .slice(0, 19)
//       .replace("T", " ");

//     // Data to save

//     const [date, time] = formattedDate.split(" "); // Split into date and time

//     // Log data to the console (optional)
//     console.log("Rescheduled Data:", date, time, Detailsiuddata, notes);

//     try {
//       // Define the request payload
//       const payload = {
//         action: "reschedule_appointment", // Fixed value to identify the action
//         api_key: 1, // Your system's API key for authentication
//         order_id: Detailsiuddata, // The ID of the appointment to reschedule
//         notes: notes, // Any notes about the reschedule
//         date: date, // New date (YYYY-MM-DD format)
//         time: time, // New time (HH:mm format)
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reshedule.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Reschedule Appointment Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       setRescheduledData(response.data);
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }

//     // Save the data into state (without displaying it on the page)

//     // Optionally, handle additional actions (like resetting the form or other states)
//     closeRescheduleModal();
//   };
//   const handleReject = async (id, e) => {
//     e.preventDefault();
//     console.log("Reject Reason:", rejectReason, id);
//     // Add your logic here to handle the reject reason
//     try {
//       // Define the request payload
//       const payload = {
//         action: "reject_appointment", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//         reject_reason: rejectReason,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Reject Appointment Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }

//     setShowForm(false); // Close the form after submission
//   };

//   const handalapointment_complete = async (id) => {
//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "complete_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_complete.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Appointment Booking Completed Successfully!");
//         const services = response.data;
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       // filteredBookings() 
//       getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const handalconfirm_appointment = async (id) => {
//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "confirm_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_confirm.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Appointment Booking Confirmed Successfully!");
//         const services = response.data;
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const deleteallbooking = async (id) => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_recurring_booking", // Action to fetch all services
//         recurring_id: id,
//         api_key: "1", // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Delete All Appointment Booking Successfully!");
//         const services = response.data;
//         console.log(services);
//         // setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//     getappointmentdetails();
//     bookeddata();
//     handleCloseModal();
//   };

//   useEffect(() => {
//     // Send a GET request to your PHP API
//     axios
//       .get(`${BaseUrl}/backend/api/services.php?action=getadmin`)
//       .then((response) => {
//         if (response.data.status === "true") {
//           console.log(response.data.data);
//           setAdminData(response.data.data);
//         } else {
//           console.log(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while fetching data");
//       });
//   }, []);

//   const getuser = async () => {
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php?getusers`,
//         {
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded", // Use form-urlencoded
//           },
//         }
//       );

//       console.log(response);

//       if (response.data.data) {
//         console.log("API Response:", response.data.data);
//         setuserdata(response.data.data);
//       } else {
//         console.log("API response is empty.");
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getuser();
//   }, []);

//   const getappointmentdetails = async () => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "getbookingdetails", // Action to fetch all services
//         order_id: Detailsiud, // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;

//         setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getappointmentdetails();
//   }, [Detailsiud]);

//   const getdata = async () => {
//     try {
//       const payload = new URLSearchParams();
//       payload.append("getallnotificationdata", "1"); // Match the PHP expected key

//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "getallbookings",
//           api_key: "1",
//           start_date: "1900-01-01",  // Very old date to include everything
//           end_date: "9999-12-31"     // Very future date to include everything
//       }
     

//       );

//       console.log(response?.data?.response);

//       if (response?.data) {
//         console.log("API Response:", response?.data?.response);
//         setNotifications(response?.data?.response);
//       } else {
//         console.log("API response is empty.");
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getdata();
//   }, []);

//   const filteredBookings = (Array.isArray(notifications) ? notifications : []).filter((booking) => {
//     const bookingDate = new Date(booking?.booking_date_time);
//     const currentDate = new Date();
//     const threeMonthsLater = new Date();
//     threeMonthsLater.setMonth(currentDate.getMonth() + 3);
  
//     return bookingDate >= currentDate && bookingDate <= threeMonthsLater;
//   }).map((booking) => {
//     const client = userdata.find((user) => user.id === booking?.client_id);
//     return {
//       ...booking,
//       clientName: client
//         ? `${client.first_name} ${client.last_name}`
//         : booking.client_id,
//     };
//   }).filter((booking) =>
//     booking.clientName.toLowerCase().includes(searchTerm.toLowerCase())
//   ).sort(
//     (a, b) => new Date(a.booking_date_time) - new Date(b.booking_date_time)
//   );

//   const bookeddata = async () => {
//     try {
//       const currentDate = new Date(); // Current date

//       // Format the date in YYYY-MM-DD format
//       const formattedDate = currentDate.toISOString().split("T")[0];

//       // Convert formattedDate back to Date object to extract year and month
//       const currentDateObj = new Date(formattedDate);

//       // Get the first day of the current month
//       const start_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth(),
//         1
//       )
//         .toISOString()
//         .split("T")[0];

//       // Get the last day of the month, 3 months from now
//       const end_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth() + 3 + 1,
//         0
//       )
//         .toISOString()
//         .split("T")[0];

//       // Define the request payload
//       const payload = {
//         action: "getallbookings", // Action to fetch all services
//         api_key: "1", // API key for authentication
//         start_date: start_date,
//         end_date: end_date,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         console.log(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services); // Log the fetched data
//           setbookingappointment(services.response);
//           // setTableData(services); // Uncomment to update the table
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const handleEditClick = async () => {
//     setShowSelected(!showSelected);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "staff_assign_to_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: detailsdata.id,
//         staff_ids: selectedStaff,
//       };

//       console.log(payload);

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/staff_assign.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         setSuccessMessage("Assign Booking To Staff successfully!");

//         console.log("API Response:", response.data);
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const handleSelectChange = (event) => {
//     const selectedId = event.target.value; // Extract values
//     setSelectedStaff(selectedId); // Update state
//   };

//   const openEditServiceModal = async (id) => {
//     setorder_id_appointment(detailsdata.id);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "get_edit_booking_info",
//           api_key: "1",
//           order_id: detailsdata.id,
//         }
//       );

//       if (response.data.status === "true") {
//         setSuccessMessage("Edit Booking Successfully!");

//         // Assuming the response structure is as you provided
//         const bookingData = response.data.response.ct_cart.method;
//         console.log(response.data);

//         setSelectedAppointment(bookingData); // Store the booking data in state
//         setShowEditServiceModal(true);
//         const serviceIds = response.data.response.ct_cart.method.map(
//           (item) => item.service_id
//         );
//         const methodIds = response.data.response.ct_cart.method.map(
//           (item) => item.method_id
//         );
//         const unitsIds = response.data.response.ct_cart.method.map(
//           (item) => item.units_id
//         );
//         const s_m_qty = response.data.response.ct_cart.method.map(
//           (item) => item.s_m_qty
//         );
//         const addonIds = response.data.response.ct_cart.method
//           .filter((item) => item.type === "addon")
//           .map((item) => item.units_id); // Capture the `units_id` for addons.

//         setUserSelectedMethods(serviceIds); // Output: ['19', '19']
//         setUserSelectedMethodsId(methodIds); // Output: ['19', '19']
//         setUserSelectedMethodsUnitsId(unitsIds);
//         setUserSelectedMethodsSmqty(s_m_qty);
//         setUserSelectedAddon(addonIds);

//         let data = services
//           .filter(
//             (id) =>
//               Array.isArray(serviceIds) && serviceIds.includes(id.service_id)
//           )
//           .map((md) => {
//             // Add filtering based on method_id
//             return md.methods
//               .filter((meData) => methodIds.includes(meData.method_id))
//               .map((filteredMethod) => {
//                 console.log(filteredMethod);
//                 return filteredMethod; // This will keep the filtered data
//               });
//           });
//         let allData = services.map((service) => {
//           return service.methods.map((method) => {
//             const filteredAddons = method.addons.filter((addon) =>
//               addonIds.includes(addon.addon_id)
//             );
//             // Map through methods and filter relevant addons
//             return {
//               ...method,
//               addons: filteredAddons, // Include only the selected addons
//             };
//           });
//         });
//         console.log("Selected Addons: ", addonIds);
//         console.log(
//           "Response Addons: ",
//           response.data.response.ct_cart.method.filter(
//             (item) => item.type === "addon"
//           )
//         );
//         console.log("------------------------------", allData);
//         // console.log("----------------------", units_id);
//         console.log("---------------------------------------------", s_m_qty);
//         console.log(
//           "---------------------------------------------",
//           data[0][0]
//         );
//         // console.log("---------------------------------------------", data[0][0][0]);
//         handleMethodSelection(data[0][0], data[0][0].method_id);
//         console.log("Selected Units: ", unitsIds);
//         console.log("Method Data: ", data[0][0]);
//         handleMethodSelection(data[0][0], data[0][0].method_id);
       
//       } else {
//         console.error(
//           "Error fetching booking details:",
//           response.data.response
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching booking details:", error);
//     }
//   };

//   // Function to handle navigation
//   const handleNavigation = (path, section = null) => {
//     navigate(path);
//     // If a section is provided, toggle its submenu
//     if (section) {
//       toggleSubmenu(section);
//     }
//   };

//   // Toggle Sidebar visibility
//   const toggleSidebar = () => {
//     setSidebarVisible(!sidebarVisible);
//   };

//   // Toggle Notification Sidebar visibility
//   const toggleNotificationSidebar = () => {
//     setNotificationSidebarVisible(!notificationSidebarVisible);
//   };

//   // Toggle submenu visibility for each section
//   const toggleSubmenu = (section) => {
//     setSubmenuVisible((prevState) => {
//       // Create a new state object with all submenus closed
//       const newState = {
//         appointment: false,
//         service: false,
//         schedule: false,
//         staff: false,
//         crm: false,
//         payment: false,
//         export: false,
//         embeded: false,
//         setting: false,
//       };

//       // Toggle the selected submenu (open if it was closed, keep closed if it was open)
//       newState[section] = !prevState[section];

//       return newState;
//     });
//   };

//   const handleProfileClick = () => {
//     // Navigate to the admin profile page
//     navigate("/admin/adminProfile");
//   };

//   const handleLogoutClick = () => {
//     // Show the confirmation modal when logout icon is clicked
//     setShowLogoutModal(true);
//   };

//   const handleLogoutConfirm = () => {
//     // Navigate to the login page when user confirms logout
//     setShowLogoutModal(false); // Close modal
//     // navigate("/login"); // Redirect to login page
//     logout(); // Call the logout function
//     console.log('Admin logged out successfully');

//     // localStorage.removeItem('isLoggedIn'); //
//     sessionStorage.removeItem('isLoggedIn'); //
//     // window.location.href = '/login'; // Example: Redirect to login page
//     navigate("/login"); 

//   };

//   const handleLogoutCancel = () => {
//     // Close the modal without logging out
//     setShowLogoutModal(false);
//   };
//   const handleShowModal = (event) => {
//     console.log(event);
//     setSelectedEvent(event);
//     setDetailsiud(event.order_id);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   const handleMethodSelection = (method, id) => {
//     switch ((method.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }

//     setSelectedMethod(method, id);
//   };


//   const admindb = () => {
//     navigate("/admin");
//   };

//   return (
//     <>
//      {successMessage && (
//         <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative ">
//           <span className="block sm:inline">{successMessage}</span>
//         </div>
//       )}

//       {error && (
//         <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
//           <span className="block sm:inline">{error}</span>
//         </div>
//       )}
//     <div className="flex min-h-screen">
     
//       {/* Sidebar */}
//       <div
//         ref={sidebarRef}
//         className={`${
//           sidebarVisible ? "block" : "hidden"
//         } fixed top-0 left-0 w-64 h-full bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 rounded-lg z-50 transition-all scrollbar-hide hide-scrollbar duration-300`}
//          style={{ maxHeight: "100vh", overflowY: "auto" }} // Allow scrolling within the sidebar
//       >
//         {/* Close Icon */}
//         <button
//           onClick={() => setSidebarVisible(false)}
//           className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//         >
//           <FiX />
//         </button>
//         <h2 className="text-2xl  font-medium text-center mb-8 cursor-pointer  hover:text-blue-500"
//         onClick={() => admindb()}
//         >
//           MegaClean
//         </h2>
//         <ul>
//           {/* Appointment Section */}
//           <li className="mb-1 ">
//             <button
//               onClick={() => handleNavigation("/admin/appointment")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={appointmentGif}
//                   alt="Appointment"
//                   className="w-12 h-12 object-contain transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Appointment
//                 </span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("appointment")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.appointment ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Submenu for Appointment */}
//             {/* {submenuVisible.appointment && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/appointments/create")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Create Appointment
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/appointments/manage")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Manage Appointment
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Service */}

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/service")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={serviceGif}
//                   alt="Service"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Service
//                 </span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("service")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.service ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Service Submenu */}
//             {/* {submenuVisible.service && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/service/create")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-black text-left transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 text-lg" />
//                     <span className="text-left">Add Service</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/service/manage")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left">Manage Services</span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Repeat the above structure for other sections: schedule, staff, crm, payment, export, settings */}

//           {/* Schedule */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/schedule")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={scheduleGif}
//                   alt="Schedule"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Schedule
//                 </span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("schedule")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.schedule ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Schedule Submenu */}
//             {/* {submenuVisible.schedule && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/create")}
//                     className="block text-gray-700 hover:bg-blue-200 p-2 rounded-md"
//                   >
//                     Create Schedule
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/manage")}
//                     className="block text-gray-700 hover:bg-blue-200 p-2 rounded-md"
//                   >
//                     Manage Schedule
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Additional menu items (Staff, CRM, Payment, Export, Settings) would follow a similar structure */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/staff", "staff")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={staffGif}
//                   alt="Staff"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Staff
//                 </span>
//               </div>
//               <FiChevronRight
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.staff ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Staff Submenu */}
//             {submenuVisible.staff && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/staff/addStaff")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
//                     <span className="text-left font-bold  hover:text-white">
//                       Staff Details
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/staff/staffPayment")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 hover:text-white" />
//                     <span className="text-left font-bold  hover:text-white">
//                       Staff Payment Details
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//           {/* {crm} */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/crm", "crm")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={crmGif}
//                   alt="CRM"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   CRM
//                 </span>
//               </div>
//               {/* <FiChevronRight
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.crm ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* CRM Submenu */}
//             {/* {submenuVisible.crm && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/crm/guestcustomer")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold  hover:text-white">
//                       Guest Customer
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Payment */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/payment", "payment")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={paymentGif}
//                   alt="Payment"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Payment
//                 </span>
//               </div>
//               <FiChevronRight
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.payment ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.payment && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/payment/staffPaymentDetails")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold hover:text-white">
//                       {" "}
//                       Staff Payment Details
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/payment/recurrenceDetail")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold  hover:text-white">
//                       Recurrence Details
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/export", "export")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={exportGif}
//                   alt="export"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Export
//                 </span>
//               </div>
//               <FiChevronRight
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.export ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.export && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/export/customerInformation")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold  hover:text-white">
//                       Customer Information
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/export/serviceInformation")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold  hover:text-white">
//                       Service Information
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/embeded")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={embedGif}
//                   alt="embeded"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium  hover:text-white">
//                   Embed Code
//                 </span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("embeded")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.embeded ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Schedule Submenu */}
//             {/* {submenuVisible.embeded && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/create")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Create </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/manage")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Manage Schedule{" "}
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

      //     <li className="mb-1 scrollbar-hide">
      //       <button
      //         onClick={() => handleNavigation("/admin/setting", "setting")}
      //         className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 scrollbar-hide transition-all duration-300 hover:text-white"
      //       >
      //         <div className="flex items-center space-x-4">
      //           <img
      //             src={settingsGif}
      //             alt="setting"
      //             className="w-12 h-12 transition-all duration-300 transform hover:scale-110"
      //           />
      //           <span className="text-lg font-medium text-ellipsis overflow-hidden whitespace-nowrap max-w-[calc(100%-3rem)]">
      //             Setting
      //           </span>
      //         </div>
      //         <FiChevronRight
      //           className={`transition-transform duration-300 transform ${
      //             submenuVisible.setting ? "rotate-90" : "rotate-0"
      //           }`}
      //         />
      //       </button>
      //       {/* Schedule Submenu */}
      //       {submenuVisible.setting && (
      //         <ul className="pl-4">
      //           {" "}
      //           {/* Adjusted padding */}
      //           {[
      //             {
      //               path: "/admin/setting/appearance",
      //               icon: <HiEye />,
      //               label: "Appearance",
      //             },
      //             {
      //               path: "/admin/setting/genral",
      //               icon: <IoIosSettings />,
      //               label: "General",
      //             },
      //             {
      //               path: "/admin/setting/payment",
      //               icon: <MdOutlinePayment />,
      //               label: "Payment",
      //             },
      //             {
      //               path: "/admin/setting/promocode",
      //               icon: <BsFileCodeFill />,
      //               label: "Promocode",
      //             },
      //             {
      //               path: "/admin/setting/smsTemplate",
      //               icon: <MdSms />,
      //               label: "SMS Template",
      //             },
      //             {
      //               path: "/admin/setting/referral",
      //               icon: <FaCode />,
      //               label: "Referral",
      //             },
      //             {
      //               path: "/admin/setting/seo",
      //               icon: <RiSeoLine />,
      //               label: "SEO",
      //             },
      //             {
      //               path: "/admin/setting/emailNotification",
      //               icon: <MdEmail />,
      //               label: "Email No",
      //             },
      //             {
      //               path: "/admin/setting/label",
      //               icon: <MdLabel />,
      //               label: "Labels",
      //             },
      //             {
      //               path: "/admin/setting/emailTemplate",
      //               icon: <MdMarkEmailUnread />,
      //               label: "Email Template",
      //             },
      //             {
      //               path: "/admin/setting/fronttooltip",
      //               icon: <TbTooltip />,
      //               label: "Front Tool Tips",
      //             },
      //             {
      //               path: "/admin/setting/smsnotification",
      //               icon: <MdSms />,
      //               label: "SMS Not",
      //             },
      //             {
      //               path: "/admin/setting/manageableForm",
      //               icon: <CgFormatJustify />,
      //               label: "Manageable Form Fields",
      //             },
      //             {
      //               path: "/admin/setting/recurrence",
      //               icon: <IoIosRefreshCircle />,
      //               label: "Recurrence",
      //             },
      //             {
      //               path: "/admin/setting/xero",
      //               icon: <SiXero />,
      //               label: "Xero",
      //             },
      //           ].map(({ path, icon, label }) => (
      //             <li key={path}>
      //               <button
      //                 onClick={() => handleNavigation(path)}
      //                 className="flex items-center space-x-3 text-gray-700 hover:bg-blue-400 p-2 rounded-md w-full hover:text-white"
      //               >
      //                 <div className="text-2xl text-gray-700 transition-all duration-300 transform hover:text-white rounded-md">
      //                   {icon}
      //                 </div>
      //                 <span className="text-left font-bold text-gray-700 transition-all duration-300 transform hover:text-white rounded-md">
      //                   {label}
      //                 </span>
      //               </button>
      //             </li>
      //           ))}
      //         </ul>
      //       )}
      //     </li>
      //   </ul>
      // </div>

//       {/* Main Layout */}
//       <div className="flex-1 flex flex-col relative">
//         {/* Header */}
//         <header className="bg-blue-800 text-white p-4 flex justify-between items-center">
//           <button onClick={toggleSidebar} className="text-white text-2xl">
//             <FiMenu />
//           </button>
//           <h1
//             onClick={() => navigate("/")}
//             className="text-2xl font-medium cursor-pointer"
//           >
//             My Booking Page
//           </h1>
//           <div className="flex items-center space-x-4">
//             {/* Notification Icon */}
//             <button onClick={toggleNotificationSidebar} className="text-white">
//               <FaBell size={24} />
//             </button>

//             {/* Profile Icon */}
//             <button onClick={handleProfileClick} className="text-white">
//               <FaUser size={24} />
//             </button>

//             {/* Logout Icon */}
//             <button onClick={handleLogoutClick} className="text-white">
//               <FaPowerOff size={24} />
//             </button>
//           </div>
//         </header>

//         {/* Logout Modal */}
//         {showLogoutModal && (
//           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 sm:w-1/3 max-w-sm">
//               <p className="text-lg font-medium text-gray-800 mb-4">
//                 Are you sure you want to log out?
//               </p>
//               <div className="flex justify-center space-x-4 mt-4">
//                 <button
//                   onClick={handleLogoutConfirm}
//                   className="px-4 py-2 bg-green-500 text-white rounded-md"
//                 >
//                   Yes
//                 </button>
//                 <button
//                   onClick={handleLogoutCancel}
//                   className="px-4 py-2 bg-red-500 text-white rounded-md"
//                 >
//                   No
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {showModal && detailsdata && (
//           <div className="fixed inset-0 py-16 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 ">
//             <div className="bg-white p-6 overflow-y-auto   h-[500px] rounded-lg w-full max-w-md sm:max-w-lg md:w-auto  lg:max-w-2xl xl:max-w-3xl min-[320px]:w-3/4 max-[640px]:w-3/4  overflow-auto">
//               {/* Modal Header */}
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold">Booking Details</h2>
//                 <button
//                   onClick={handleCloseModal}
//                   className="text-gray-500 hover:text-gray-700 font-bold"
//                 >
//                   X
//                 </button>
//               </div>

//               {/* Booking Info */}
//               <div className="space-y-6">
//                 <div className="flex flex-col sm:flex-row justify-between items-center">
//                   <span className="font-medium mb-3 ">Booking Status:</span>
//                   <span className="text-green-500 mb-3">
//                     {detailsdata.booking_status}
//                   </span>
//                   <button
//                     onClick={() => openEditServiceModal()}
//                     className="text-black flex items-center gap-2 p-2 border rounded-md hover:bg-blue-500 hover:text-white"
//                   >
//                     {/* <FaEdit /> Edit Booking Details */}
//                   </button>
//                 </div>

//                 <div className="space-y-4">
//                   <table>
//                     <tr>
//                       <td className="font-bold w-24">Booking Date </td>

//                       <td>
//                         {detailsdata?.appointment_starttime}
//                         {detailsdata?.appointment_start_time}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold">Service</td>
//                       <td>{detailsdata?.service_title}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold">Methods</td>
//                       <td>{detailsdata?.method_title}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold">Units</td>
//                       <td>{detailsdata?.unit_title}</td>
//                     </tr>{" "}
//                     <tr>
//                       <td className="font-bold">Addons</td>
//                       <td>{detailsdata?.addons_title}</td>
//                     </tr>{" "}
//                     <tr>
//                       <td className="font-bold">Price</td>
//                       <td>{detailsdata?.booking_price}</td>
//                     </tr>{" "}
//                     <tr>
//                       <td className="font-bold">Duration</td>
//                       <td>{detailsdata?.booking_duration}</td>
//                     </tr>
//                   </table>
//                 </div>
//                 <div className="flex justify-between">
//                   <h2 className="text-xl font-bold">Customer Detail</h2>
//                   <Link to={`editCustomer/${selectedEvent.client_id}`}>
//                     <button className="text-blue-500 mt-2 sm:mt-0">
//                       <span className="text-2xl">{/* <BiSolidEdit /> */}</span>
//                     </button>
//                   </Link>
//                 </div>

//                 {/* Customer Information */}
//                 <div className="space-y-4">
//                   <table>
//                     <tr>
//                       <td className="font-bold w-20">Name</td>
//                       <td>{detailsdata?.client_name}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold ">Email </td>
//                       <td>{detailsdata?.client_email}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold ">Phone:</td>
//                       <td>{detailsdata?.client_phone}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold ">Notes:</td>
//                       <td>{detailsdata?.client_notes}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold">Address:</td>
//                       <td>
//                         <a
//                           href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//                             detailsdata?.client_address
//                           )}`}
//                           target="_blank"
//                           style={{ color: "blue" }}
//                           rel="noopener noreferrer"
//                         >
//                           {detailsdata?.client_address}
//                         </a>
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-bold ">Payment:</td>
//                       <td>{detailsdata?.payment_type}</td>
//                     </tr>
//                   </table>
//                 </div>
//                 {/* Assign Appointment */}
//                 <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
//                   <div className="flex items-center w-full sm:w-auto">
//                     <span className="mr-2">Assign Appointment to Staff:</span>
//                     <select
//                       className="border p-2 rounded-md w-full sm:w-auto"
//                       value={selectedStaff || ""}
//                       onChange={handleSelectChange}
//                     >
//                       <option value="">Nothing selected</option>
//                       {adminData && adminData.length > 0 ? (
//                         adminData.map((staff, index) => (
//                           <option key={index} value={staff.id}>
//                             {staff.fullname}
//                           </option>
//                         ))
//                       ) : (
//                         <option value="">No staff available</option>
//                       )}
//                     </select>
//                   </div>

//                   <div className="mt-2 sm:mt-0 sm:ml-4">
//                     <button className="text-blue-500" onClick={handleEditClick}>
//                       <span className="text-2xl">
//                         <BiSolidEdit />
//                       </span>
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
//                 {detailsdata.booking_status === "R" && (
//                   <>
//                     <button
//                       type="button"
//                       onClick={() => handaldeleted(detailsdata.id)}
//                       className="text-red-500 font-semiboldpx-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       ✖ Delete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       🗑️ Delete All Recurring
//                     </button>
//                   </>
//                 )}

//                 {detailsdata.booking_status === "A" && (
//                   <>
//                     <button
//                       type="button"
//                       onClick={() => handalconfirm_appointment(detailsdata.id)}
//                       className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                     >
//                       ✔ confirm
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => handleRescheduleClick(detailsdata.id)}
//                       className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                     >
//                       ↻ Reschedule
//                     </button>

//                     <button
//                       type="button"
//                       onClick={handleRejectClick}
//                       className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       👎🏻 Reject
//                     </button>

//                     {/* Reschedule Modal */}
//                     {detailsdata && showRescheduleModal && (
//                       <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                         <div className="bg-white p-6 rounded-md shadow-lg w-96">
//                           <h2 className="text-lg font-semibold mb-4">
//                             Reschedule Appointment
//                           </h2>
//                           {/* Amount Input */}
//                           <div className="mb-4">
//                             <label
//                               htmlFor="amount"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Amount:
//                             </label>
//                             <input
//                               type="number"
//                               id="amount"
//                               value={
//                                 detailsdata?.booking_price
//                                   ? detailsdata.booking_price.replace(
//                                       /[^0-9.-]+/g,
//                                       ""
//                                     )
//                                   : ""
//                               }
//                               className="w-full px-3 py-2 border rounded-md"
//                             />
//                           </div>

//                           {/* Date Picker (Calendar) */}
//                           <div className="mb-4">
//                             <label
//                               htmlFor="date"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Select Date:
//                             </label>
//                             <input
//                               type="datetime-local"
//                               id="date"
//                               value={rescheduleDate}
//                               onChange={(e) =>
//                                 setRescheduleDate(e.target.value)
//                               }
//                               className="w-full px-3 py-2 border rounded-md"
//                             />
//                           </div>

//                           {/* Notes Input */}
//                           <div className="mb-4">
//                             <label
//                               htmlFor="notes"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Notes:
//                             </label>
//                             <textarea
//                               id="notes"
//                               value={notes}
//                               onChange={(e) => setNotes(e.target.value)}
//                               className="w-full px-3 py-2 border rounded-md"
//                               placeholder="Add any notes"
//                             />
//                           </div>

//                           {/* Action Buttons */}
//                           <div className="flex justify-end gap-4">
//                             <button
//                               type="button"
//                               onClick={closeRescheduleModal}
//                               className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                             >
//                               Cancel
//                             </button>
//                             <button
//                               type="submit"
//                               onClick={(e) => handleUpdate(e, rescheduleDate)}
//                               className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                             >
//                               Update
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     )}

//                     {/* Reject Form */}
//                     {showForm && (
//                       <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                         <form
//                           onSubmit={(e) => handleReject(detailsdata.id, e)}
//                           className="bg-white p-6 rounded-md shadow-lg w-96"
//                         >
//                           <h2 className="text-lg font-semibold mb-4">
//                             Enter Reject Reason
//                           </h2>
//                           <label
//                             htmlFor="rejectReason"
//                             className="block text-gray-700 mb-2"
//                           >
//                             Reason:
//                           </label>
//                           <input
//                             type="text"
//                             id="rejectReason"
//                             value={rejectReason}
//                             onChange={(e) => setRejectReason(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md mb-4"
//                             placeholder="Reason for rejection"
//                           />
//                           <div className="flex justify-end gap-4">
//                             <button
//                               type="button"
//                               onClick={() => setShowForm(false)}
//                               className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                             >
//                               Cancel
//                             </button>
//                             <button
//                               type="submit"
//                               className="bg-red-500 text-white px-4 py-2 rounded-md"
//                             >
//                               Submit
//                             </button>
//                           </div>
//                         </form>
//                       </div>
//                     )}

//                     <button
//                       type="button"
//                       onClick={() => handaldeleted(detailsdata.id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       ✖ Delete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       🗑️ Delete All Recurring
//                     </button>
//                   </>
//                 )}

//                 {detailsdata.booking_status === "C" && (
//                   <>
//                     <button
//                       type="button"
//                       onClick={() => handalapointment_complete(detailsdata.id)}
//                       className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                     >
//                       ✔ Complete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => handaldeleted(detailsdata.id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       ✖ Delete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       🗑️ Delete All Recurring
//                     </button>
//                   </>
//                 )}
//                 {detailsdata.booking_status === "RS" && (
//                   <>
//                     <button
//                       type="button"
//                       onClick={() => handalapointment_complete(detailsdata.id)}
//                       className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                     >
//                       👍 Complete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => handleRescheduleClick(detailsdata.id)}
//                       className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                     >
//                       ↻ Reschedule
//                     </button>

//                     <button
//                       type="button"
//                       onClick={handleRejectClick}
//                       className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       👎🏻 Reject
//                     </button>

//                     {/* Reschedule Modal */}
//                     {detailsdata && showRescheduleModal && (
//                       <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                         <div className="bg-white p-6 rounded-md shadow-lg w-96">
//                           <h2 className="text-lg font-semibold mb-4">
//                             Reschedule Appointment
//                           </h2>
//                           {/* Amount Input */}
//                           <div className="mb-4">
//                             <label
//                               htmlFor="amount"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Amount:
//                             </label>
//                             <input
//                               type="number"
//                               id="amount"
//                               value={
//                                 detailsdata?.booking_price
//                                   ? detailsdata.booking_price.replace(
//                                       /[^0-9.-]+/g,
//                                       ""
//                                     )
//                                   : ""
//                               }
//                               className="w-full px-3 py-2 border rounded-md"
//                             />
//                           </div>

//                           {/* Date Picker (Calendar) */}
//                           <div className="mb-4">
//                             <label
//                               htmlFor="date"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Select Date:
//                             </label>
//                             <input
//                               type="datetime-local"
//                               id="date"
//                               value={rescheduleDate}
//                               onChange={(e) =>
//                                 setRescheduleDate(e.target.value)
//                               }
//                               className="w-full px-3 py-2 border rounded-md"
//                             />
//                           </div>

//                           {/* Notes Input */}
//                           <div className="mb-4">
//                             <label
//                               htmlFor="notes"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Notes:
//                             </label>
//                             <textarea
//                               id="notes"
//                               value={notes}
//                               onChange={(e) => setNotes(e.target.value)}
//                               className="w-full px-3 py-2 border rounded-md"
//                               placeholder="Add any notes"
//                             />
//                           </div>

//                           {/* Action Buttons */}
//                           <div className="flex justify-end gap-4">
//                             <button
//                               type="button"
//                               onClick={closeRescheduleModal}
//                               className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                             >
//                               Cancel
//                             </button>
//                             <button
//                               type="submit"
//                               onClick={(e) => handleUpdate(e, rescheduleDate)}
//                               className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                             >
//                               Update
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     )}

//                     {/* Reject Form */}
//                     {showForm && (
//                       <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                         <form
//                           onSubmit={(e) => handleReject(detailsdata.id, e)}
//                           className="bg-white p-6 rounded-md shadow-lg w-96"
//                         >
//                           <h2 className="text-lg font-semibold mb-4">
//                             Enter Reject Reason
//                           </h2>
//                           <label
//                             htmlFor="rejectReason"
//                             className="block text-gray-700 mb-2"
//                           >
//                             Reason:
//                           </label>
//                           <input
//                             type="text"
//                             id="rejectReason"
//                             value={rejectReason}
//                             onChange={(e) => setRejectReason(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md mb-4"
//                             placeholder="Reason for rejection"
//                           />
//                           <div className="flex justify-end gap-4">
//                             <button
//                               type="button"
//                               onClick={() => setShowForm(false)}
//                               className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                             >
//                               Cancel
//                             </button>
//                             <button
//                               type="submit"
//                               className="bg-red-500 text-white px-4 py-2 rounded-md"
//                             >
//                               Submit
//                             </button>
//                           </div>
//                         </form>
//                       </div>
//                     )}

//                     <button
//                       type="button"
//                       onClick={() => handaldeleted(detailsdata.id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       ✖ Delete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       🗑️ Delete All Recurring
//                     </button>
//                   </>
//                 )}

//                 {detailsdata.booking_status === "CO" && (
//                   <>
//                     <div className="text-gray-500">
//                       This Appointment Is Completed
//                     </div>

//                     <button
//                       type="button"
//                       onClick={() => handaldeleted(detailsdata.id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       ✖ Delete
//                     </button>

//                     <button
//                       type="button"
//                       onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                       className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                     >
//                       🗑️ Delete All Recurring
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Sidebar */}
//         {notificationSidebarVisible && (
//           <div
//             ref={sidebarRef}
//             className="fixed top-0 right-0 w-80 bg-white text-black p-6 shadow-lg border-l-4 border-blue-800 z-50 transition-all duration-300 max-h-screen overflow-y-auto"
//           >
//             {/* Close Button */}
//             <button
//               onClick={() => setNotificationSidebarVisible(false)}
//               className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//             >
//               <FiX />
//             </button>

//             {/* Sidebar Title */}
//             <h2 className="text-2xl font-medium mb-4">Booking Information</h2>

//             {/* Search Input */}
//             <input
//               type="text"
//               placeholder="Search by name..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-md focus:shadow-lg transition-shadow"
//             />

//             {/* Filtered Booking List */}
//             {filteredBookings.length > 0 ? (
//               filteredBookings.map((booking, index) => {
//                 const bookingDate = new Date(booking.booking_date_time);
//                 const today = new Date();

//                 // Normalize today's date (remove time for accurate comparison)
//                 today.setHours(0, 0, 0, 0);
//                 bookingDate.setHours(0, 0, 0, 0);

//                 const timeDiff = bookingDate - today;
//                 const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

//                 // Calculate remaining time (days or months)
//                 let timeText;
//                 if (daysDiff === 0) {
//                   timeText = "Today";
//                 } else if (daysDiff >= 30) {
//                   const months = Math.floor(daysDiff / 30); // Only full months
//                   timeText = `${months} ${months > 1 ? "months" : "month"}`;
//                 } else {
//                   timeText = `${daysDiff} ${daysDiff > 1 ? "days" : "day"}`;
//                 }
//                 // Status mapping
//                 const statusLabels = {
//                   A: "Active",
//                   C: "Confirm",
//                   R: "Rejected",
//                   CC: "Customer Cancelled",
//                   CS: "Customer Service",
//                   CO: "Completed",
//                   MC: "Manager Confirmed",
//                   RS: "Rescheduled",
//                 };

//                 return (
//                   <div
//                     key={index}
//                     className="mb-4 p-4 border rounded-lg shadow-md bg-gray-100 transition-all duration-300 transform hover:shadow-xl hover:scale-[1.02]"
//                   >
//                     <p className="text-lg text-gray-700">
//                       {booking.clientName} for {booking.title} on{" "}
//                       <strong>{booking.booking_date_time}</strong>{" "}
//                       {/* Only Date */}
//                     </p>

//                     {/* Show remaining or late days in proper format */}
//                     <p
//                       className={`font-medium ${
//                         daysDiff < 0 ? "text-red-500" : "text-blue-500"
//                       }`}
//                     >
//                       {daysDiff < 0
//                         ? `${Math.abs(daysDiff)} days late`
//                         : `${timeText} remaining`}
//                     </p>

//                     <button
//                       className={`px-4 py-2 rounded-lg transition-all duration-300 transform hover:scale-110 ${
//                         booking.booking_status === "A"
//                           ? "bg-green-500 text-white"
//                           : booking.booking_status === "C" ||
//                             booking.booking_status === "R" ||
//                             booking.booking_status === "CC"
//                           ? "bg-red-500 text-white"
//                           : booking.booking_status === "CO"
//                           ? "bg-blue-500 text-white"
//                           : "bg-yellow-500 text-white"
//                       }`}
//                       onClick={() => handleShowModal(booking)}
//                     >
//                       {statusLabels[booking.booking_status] || "Unknown"}
//                     </button>
//                   </div>
//                 );
//               })
//             ) : (
//               <p className="text-gray-500">No bookings found</p>
//             )}
//           </div>
//         )}
//         {/* Content Section */}
//         <main className=" flex-1 p-8">
//           <Outlet /> {/* This renders the matching route content */}
//         </main>
//       </div>
//     </div>
//     </>
//   );
// };

// export default AdminPanel;





// import React, { useState,useRef,useEffect } from "react";
// import {Link, useNavigate } from "react-router-dom";
// import { FiMenu, FiChevronRight, FiPlus, FiList, FiX } from "react-icons/fi"; // Import hamburger and right-chevron icon
// import { Outlet } from "react-router-dom";
// import { FaBell, FaUser } from 'react-icons/fa';
// import { FaPowerOff } from "react-icons/fa6";
// import { MdOutlinePayment } from "react-icons/md";
// import {  IoBook } from "react-icons/io5";
// import { HiEye } from "react-icons/hi2";
// import { MdEmail,MdSms, MdLabel  } from "react-icons/md";
// import { BsFileCodeFill } from "react-icons/bs";
// import { IoIosSettings } from "react-icons/io";
// import { FaCode } from "react-icons/fa";
// // Import GIFs from your assets folder
// import appointmentGif from "../assets/appointment.gif";
// import serviceGif from "../assets/service.gif";
// import scheduleGif from "../assets/schedule.gif";
// import staffGif from "../assets/staff.gif";
// import crmGif from "../assets/crm.gif";
// import paymentGif from "../assets/payment.gif";
// import exportGif from "../assets/export.gif";
// import settingsGif from "../assets/settings.gif";
// import embedGif from "../assets/embeded.gif";
// import {FaEdit} from "react-icons/fa";
// import { BiSolidEdit } from "react-icons/bi";
// import axios from "axios";
// import { BaseUrl } from "../App";

// const AdminPanel = () => {
//   const sidebarRef = useRef(null);
//   const navigate = useNavigate(); // Initialize navigate hook
//   const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar starts as hidden
//   const [notificationSidebarVisible, setNotificationSidebarVisible] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [notifications, setNotifications] = useState([]); // State for notifications
//   const [userdata, setuserdata] = useState([]); // State for notifications
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [selectedStaff, setSelectedStaff] = useState([]);
//   const [showSelected, setShowSelected] = useState(false);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   console.log(userdata);
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [adminData, setAdminData] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [Detailsiud, setDetailsiud] = useState(null); // Set default to
//     const [detailsdata, setDetailsdata] = useState({});
//     const [order_id_appointment, setorder_id_appointment] = useState(0);
//     const [showEditServiceModal, setShowEditServiceModal] = useState(false);
//     const [userSelectedMethods, setUserSelectedMethods] = useState(null);
//     const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
//     const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] =
//       useState(null);
//     const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] =
//       useState(null);
//           const [selectedAppointment, setSelectedAppointment] = useState(null);
//           const [userSelectedAddon, setUserSelectedAddon] = useState(null);
//           const [services, setServices] = useState([]);
//            const [bookingappointment, setbookingappointment] = useState([]);
//   const [isBookingComplete, setIsBookingComplete] = useState(false);
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [Detailsiuddata, setDetailsiuddata] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
//   const [notes, setNotes] = useState("");
//   const [rescheduledData, setRescheduledData] = useState(null);
//   const [rejectReason, setRejectReason] = useState("");

//   const [submenuVisible, setSubmenuVisible] = useState({
//     appointment: false,
//     service: false,
//     schedule: false,
//     staff: false,
//     crm: false,
//     payment: false,
//     export: false,
//     embeded: false,
//     setting: false,
//   }); // State for submenu visibility
//   const handleRescheduleClick = (id) => {
//     setShowRescheduleModal(true);
//     setDetailsiuddata(id);
//   };

// // Example:  Accessing the sidebar's DOM node
// const handleClickOutside = (event) => {
//   if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//       // Click was outside the sidebar
//       setSidebarVisible(false);

//   }
// };

// useEffect(() => {
//   document.addEventListener('mousedown', handleClickOutside);
//   return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//   };
// }, []);

//   const handaldeleted = async (id) => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };
//   const handleRejectClick = () => {
//     setShowForm(!showForm); // Toggle form visibility
//   };

//   const closeRescheduleModal = () => {
//     // Changed name here
//     setShowRescheduleModal(false);
//   };
//   const handleUpdate = async (e, rescheduleDate) => {
//     e.preventDefault();

//     // Validate the rescheduleDate
//     if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
//       alert("Invalid date. Please provide a valid date.");
//       return;
//     }

//     // Format the reschedule date into a readable format
//     const formattedDate = new Date(rescheduleDate)
//       .toISOString()
//       .slice(0, 19)
//       .replace("T", " ");

//     // Data to save

//     const [date, time] = formattedDate.split(" "); // Split into date and time

// // Log data to the console (optional)
// console.log("Rescheduled Data:", date, time, Detailsiuddata, notes);

//     try {
//       // Define the request payload
//        const payload = {
//     action: "reschedule_appointment", // Fixed value to identify the action
//     api_key: 1,                       // Your system's API key for authentication
//     order_id: Detailsiuddata,                 // The ID of the appointment to reschedule
//     notes: notes,                      // Any notes about the reschedule
//     date: date,                        // New date (YYYY-MM-DD format)
//     time: time                         // New time (HH:mm format)
//   };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reshedule.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//     setRescheduledData(response.data);

//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }

//     // Save the data into state (without displaying it on the page)

//     // Optionally, handle additional actions (like resetting the form or other states)
//     closeRescheduleModal();
//   };
//   const handleReject = async (id, e) => {
//     e.preventDefault();
//     console.log("Reject Reason:", rejectReason, id);
//     // Add your logic here to handle the reject reason
//     try {
//       // Define the request payload
//       const payload = {
//         action: "reject_appointment", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//         reject_reason: rejectReason,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }

//     setShowForm(false); // Close the form after submission
//   };

//   const handalapointment_complete = async (id) => {
//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "complete_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_complete.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const handalconfirm_appointment = async (id) => {
//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "confirm_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_confirm.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const deleteallbooking = async (id) => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_recurring_booking", // Action to fetch all services
//         recurring_id: id,
//         api_key: "1", // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//         // setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//     bookeddata();
//     handleCloseModal();
//   };

//   useEffect(() => {
//     // Send a GET request to your PHP API
//     axios
//       .get(
//         `${BaseUrl}/backend/api/services.php?action=getadmin`
//       )
//       .then((response) => {
//         if (response.data.status === "true") {
//           console.log(response.data.data)
//           setAdminData(response.data.data);
//         } else {
//           console.log(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while fetching data");
//       });
//   }, []);

//   const getuser = async () => {
//     try {

//       const response = await axios.post(
//         `${BaseUrl}/backend/assets/lib/my_appoint_ajax.php?action=getusers`,
//         {
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded", // Use form-urlencoded
//           },
//         }
//       );

//       console.log(response);

//       if (response.data.data) {
//         console.log("API Response:", response.data.data);
//         setuserdata(response.data.data);
//       } else {
//         console.log("API response is empty.");
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getuser();
//   }, []);

//   const getappointmentdetails = async () => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "getbookingdetails", // Action to fetch all services
//         order_id: Detailsiud, // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;

//         setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getappointmentdetails();
//   }, [Detailsiud]);

//   const getdata = async () => {
//     try {
//       const payload = new URLSearchParams();
//       payload.append("getallnotificationdata", "1"); // Match the PHP expected key

//       const response = await axios.post(
//         `${BaseUrl}/backend/assets/lib/my_appoint_ajax.php`,
//         payload, // Send as form data
//         {
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded", // Use form-urlencoded
//           },
//         }
//       );

//       console.log(response);

//       if (response.data) {
//         console.log("API Response:", response.data);
//         setNotifications(response.data);
//       } else {
//         console.log("API response is empty.");
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getdata();
//   }, []);

//   const filteredBookings = notifications
//   .filter((booking) => {
//     const bookingDate = new Date(booking.booking_date_time);
//     const currentDate = new Date();
//     const threeMonthsLater = new Date();
//     threeMonthsLater.setMonth(currentDate.getMonth() + 3);

//     return bookingDate >= currentDate && bookingDate <= threeMonthsLater;
//   })
//   .map((booking) => {
//     // Find the matching user by client_id
//     const client = userdata.find((user) => user.id === booking.client_id);
//     return {
//       ...booking,
//       clientName: client ? `${client.first_name} ${client.last_name}` : booking.client_id,
//     };
//   })
//   .filter((booking) =>
//     booking.clientName.toLowerCase().includes(searchTerm.toLowerCase())
//   ) // Filter bookings based on search input
//   .sort((a, b) => new Date(a.booking_date_time) - new Date(b.booking_date_time));

//   const bookeddata = async () => {
//     try {
//       const currentDate = new Date(); // Current date

//       // Format the date in YYYY-MM-DD format
//       const formattedDate = currentDate.toISOString().split("T")[0];

//       // Convert formattedDate back to Date object to extract year and month
//       const currentDateObj = new Date(formattedDate);

//       // Get the first day of the current month
//       const start_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth(),
//         1
//       )
//         .toISOString()
//         .split("T")[0];

//       // Get the last day of the month, 3 months from now
//       const end_date = new Date(
//         currentDateObj.getFullYear(),
//         currentDateObj.getMonth() + 3 + 1,
//         0
//       )
//         .toISOString()
//         .split("T")[0];

//       // Define the request payload
//       const payload = {
//         action: "getallbookings", // Action to fetch all services
//         api_key: "1", // API key for authentication
//         start_date: start_date,
//         end_date: end_date,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         console.log(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services); // Log the fetched data
//           setbookingappointment(services.response);
//           // setTableData(services); // Uncomment to update the table
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   const handleEditClick = async() => {
//     setShowSelected(!showSelected);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "staff_assign_to_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: detailsdata.id,
//         staff_ids: selectedStaff,
//       };

//       console.log(payload)

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/staff_assign.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }

//   };

//   const handleSelectChange = (event) => {
//     const selectedId = event.target.value;// Extract values
//     setSelectedStaff(selectedId); // Update state
//   };

//   const openEditServiceModal = async (id) => {
//     setorder_id_appointment(detailsdata.id);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "get_edit_booking_info",
//           api_key: "1",
//           order_id: detailsdata.id,
//         }
//       );

//       if (response.data.status === "true") {
//         // Assuming the response structure is as you provided
//         const bookingData = response.data.response.ct_cart.method;
//         console.log(response.data)

//         setSelectedAppointment(bookingData); // Store the booking data in state
//         setShowEditServiceModal(true);
//         const serviceIds = response.data.response.ct_cart.method.map(
//           (item) => item.service_id
//         );
//         const methodIds = response.data.response.ct_cart.method.map(
//           (item) => item.method_id
//         );
//         const unitsIds = response.data.response.ct_cart.method.map(
//           (item) => item.units_id
//         );
//         const s_m_qty = response.data.response.ct_cart.method.map(
//           (item) => item.s_m_qty
//         );
//         const addonIds = response.data.response.ct_cart.method
//         .filter(item => item.type === "addon")
//         .map(item => item.units_id); // Capture the `units_id` for addons.

//         setUserSelectedMethods(serviceIds); // Output: ['19', '19']
//         setUserSelectedMethodsId(methodIds); // Output: ['19', '19']
//         setUserSelectedMethodsUnitsId(unitsIds);
//         setUserSelectedMethodsSmqty(s_m_qty);
//         setUserSelectedAddon(addonIds);

//         let data = services
//           .filter(
//             (id) =>
//               Array.isArray(serviceIds) && serviceIds.includes(id.service_id)
//           )
//           .map((md) => {
//             // Add filtering based on method_id
//             return md.methods
//               .filter((meData) => methodIds.includes(meData.method_id))
//               .map((filteredMethod) => {
//                 console.log(filteredMethod);
//                 return filteredMethod; // This will keep the filtered data
//               });
//           });
//           let allData = services.map(service => {
//             return service.methods.map(method => {
//               const filteredAddons = method.addons.filter(addon => addonIds.includes(addon.addon_id));
//               // Map through methods and filter relevant addons
//               return {
//                 ...method,
//                 addons: filteredAddons // Include only the selected addons
//               };
//             });
//           });
//           console.log("Selected Addons: ", addonIds);
//           console.log("Response Addons: ", response.data.response.ct_cart.method.filter(item => item.type === "addon"));
//                     console.log("------------------------------",allData )
// // console.log("----------------------", units_id);
//         console.log("---------------------------------------------", s_m_qty);
//         console.log("---------------------------------------------", data[0][0]);
//         // console.log("---------------------------------------------", data[0][0][0]);
//         handleMethodSelection(data[0][0], data[0][0].method_id);
//         console.log("Selected Units: ", unitsIds);
//         console.log("Method Data: ", data[0][0]);
//         handleMethodSelection(data[0][0], data[0][0].method_id);
//         // handleMethodSelection(data[0][0][0], data[0][0][0].method_id);
//         // if (userSelectedMethodsId.includes(method.method_id) && !methodSelectedRef.current) {
//         //   methodSelectedRef.current = true; // Mark as selected
//         //   handleMethodSelection(method, method.method_id);
//         // }
//       } else {
//         console.error(
//           "Error fetching booking details:",
//           response.data.response
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching booking details:", error);
//     }
//   };

//   // Function to handle navigation
//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   // Toggle Sidebar visibility
//   const toggleSidebar = () => {
//     setSidebarVisible(!sidebarVisible);
//   };

//   // Toggle Notification Sidebar visibility
//   const toggleNotificationSidebar = () => {
//     setNotificationSidebarVisible(!notificationSidebarVisible);
//   }

//   // Toggle submenu visibility for each section
//   const toggleSubmenu = (section) => {
//     setSubmenuVisible((prevState) => ({
//       ...prevState,
//       [section]: !prevState[section],
//     }));
//   };

//   const handleProfileClick = () => {
//     // Navigate to the admin profile page
//     navigate("adminProfile");
//   };

//   const handleLogoutClick = () => {
//     // Show the confirmation modal when logout icon is clicked
//     setShowLogoutModal(true);
//   };

//   const handleLogoutConfirm = () => {
//     // Navigate to the login page when user confirms logout
//     setShowLogoutModal(false); // Close modal
//     navigate("/"); // Redirect to login page
//   };

//   const handleLogoutCancel = () => {
//     // Close the modal without logging out
//     setShowLogoutModal(false);
//   };
//   const handleShowModal = (event) => {
//     console.log(event);
//     setSelectedEvent(event);
//     setDetailsiud(event.order_id);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   const handleMethodSelection = (method, id) => {
//     switch ((method.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }

//     setSelectedMethod(method, id);
//   };

//   return (
//     <div className="flex min-h-screen">
//       {/* Sidebar */}
//       <div
//       ref={sidebarRef}
//         className={`${
//           sidebarVisible ? "block" : "hidden"
//         } fixed top-0 left-0 w-64 h-full bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 rounded-lg z-50 transition-all duration-300`}
//         style={{ maxHeight: "100vh", overflowY: "auto" }} // Allow scrolling within the sidebar
//       >
//         {/* Close Icon */}
//         <button
//           onClick={() => setSidebarVisible(false)}
//           className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//         >
//           <FiX />
//         </button>
//         <h2 className="text-2xl font-medium text-center mb-8">Cleanto</h2>
//         <ul>
//           {/* Appointment Section */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/appointment")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={appointmentGif}
//                   alt="Appointment"
//                   className="w-12 h-12 object-contain transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Appointment</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("appointment")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.appointment ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Submenu for Appointment */}
//             {/* {submenuVisible.appointment && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/appointments/create")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Create Appointment
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/appointments/manage")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Manage Appointment
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Service */}

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/service")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={serviceGif}
//                   alt="Service"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Service</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("service")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.service ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Service Submenu */}
//             {/* {submenuVisible.service && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/service/create")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-black text-left transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 text-lg" />
//                     <span className="text-left">Add Service</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/service/manage")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left">Manage Services</span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Repeat the above structure for other sections: schedule, staff, crm, payment, export, settings */}

//           {/* Schedule */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/schedule")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={scheduleGif}
//                   alt="Schedule"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Schedule</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("schedule")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.schedule ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Schedule Submenu */}
//             {/* {submenuVisible.schedule && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/create")}
//                     className="block text-gray-700 hover:bg-blue-200 p-2 rounded-md"
//                   >
//                     Create Schedule
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/manage")}
//                     className="block text-gray-700 hover:bg-blue-200 p-2 rounded-md"
//                   >
//                     Manage Schedule
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Additional menu items (Staff, CRM, Payment, Export, Settings) would follow a similar structure */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/staff")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={staffGif}
//                   alt="Staff"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Staff</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("staff")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.staff ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Staff Submenu */}
//             {submenuVisible.staff && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/staff/addStaff")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Staff Details</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/staff/staffPayment")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Staff Payment Details
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//           {/* {crm} */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/crm")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={crmGif}
//                   alt="CRM"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">CRM</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("crm")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.crm ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* CRM Submenu */}
//             {submenuVisible.crm && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/crm/guestcustomer")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Guest Customer</span>
//                   </button>
//                 </li>

//               </ul>
//             )}
//           </li>

//           {/* Payment */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/payment")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={paymentGif}
//                   alt="Payment"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Payment</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("payment")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.payment ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.payment && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/payment/staffPaymentDetails")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Staff Payment Details
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/payment/recurrenceDetail")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Recurrence Details
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/export")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={exportGif}
//                   alt="export"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Export</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("export")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.export ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.export && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/export/customerInformation")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Customer Information
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/export/serviceInformation")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Service Information
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/embeded")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={embedGif}
//                   alt="embeded"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Embed Code</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("embeded")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.embeded ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Schedule Submenu */}
//             {/* {submenuVisible.embeded && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/create")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Create </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/manage")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Manage Schedule{" "}
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/setting")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={settingsGif}
//                   alt="setting"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110  "
//                 />
//                 <span className="text-lg font-medium">Setting</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("setting")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.setting ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.setting && (
//               <ul className="pl-16">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/appearance")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <HiEye className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold "> Appearance</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/genral")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <IoIosSettings className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> General</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/payment")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdOutlinePayment className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Payment </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/promocode")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <BsFileCodeFill className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Promocode </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/smsTemplate")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdSms className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> SMS Template</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/referral")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FaCode className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Referral</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/seo")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     SEO
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/quickbook")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <IoBook className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Quick Book </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/emailNotification")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdEmail className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Email No</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/label")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdLabel className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Labels </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/emailTemplate")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Email Template
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/fronttooltip")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Front Tool Tips
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/smsnotification")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdSms className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> SMS Not </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/manageableForm")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdSms className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Manageable Form Fields{" "}
//                     </span>
//                   </button>
//                 </li>

//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/recurrence")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Recurrence
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/xero")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Xero
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//         </ul>
//       </div>

//       {/* Main Layout */}
//       <div className="flex-1 flex flex-col relative">
//         {/* Header */}
//         <header className="bg-blue-800 text-white p-4 flex justify-between items-center">
//           <button onClick={toggleSidebar} className="text-white text-2xl">
//             <FiMenu />
//           </button>
//           <h1
//             onClick={() => navigate("/my-booking")}
//             className="text-2xl font-medium cursor-pointer"
//           >
//             My Booking Page
//           </h1>
//           <div className="flex items-center space-x-4">
//             {/* Notification Icon */}
//             <button onClick={toggleNotificationSidebar} className="text-white">
//               <FaBell size={24} />
//             </button>

//             {/* Profile Icon */}
//             <button onClick={handleProfileClick} className="text-white">
//               <FaUser size={24} />
//             </button>

//             {/* Logout Icon */}
//             <button onClick={handleLogoutClick} className="text-white">
//               <FaPowerOff size={24} />
//             </button>
//           </div>
//         </header>

//         {/* Logout Modal */}
//         {showLogoutModal && (
//           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 sm:w-1/3 max-w-sm">
//               <p className="text-lg font-medium text-gray-800 mb-4">
//                 Are you sure you want to log out?
//               </p>
//               <div className="flex justify-center space-x-4 mt-4">
//                 <button
//                   onClick={handleLogoutConfirm}
//                   className="px-4 py-2 bg-green-500 text-white rounded-md"
//                 >
//                   Yes
//                 </button>
//                 <button
//                   onClick={handleLogoutCancel}
//                   className="px-4 py-2 bg-red-500 text-white rounded-md"
//                 >
//                   No
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

// {showModal && detailsdata && (
//         <div
//         className="fixed inset-0 py-16 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 ">
//           <div className="bg-white p-6 overflow-y-auto   h-[500px] rounded-lg w-full max-w-md sm:max-w-lg md:w-auto  lg:max-w-2xl xl:max-w-3xl min-[320px]:w-3/4 max-[640px]:w-3/4  overflow-auto">
//             {/* Modal Header */}
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-bold">Booking Details</h2>
//               <button
//                 onClick={handleCloseModal}
//                 className="text-gray-500 hover:text-gray-700 font-bold"
//               >
//                 X
//               </button>
//             </div>

//             {/* Booking Info */}
//             <div className="space-y-6">
//               <div className="flex flex-col sm:flex-row justify-between items-center">
//                 <span className="font-medium mb-3 ">Booking Status:</span>
//                 <span className="text-green-500 mb-3">
//                   {detailsdata.booking_status}
//                 </span>
//                 <button
//                   onClick={() => openEditServiceModal()}
//                   className="text-black flex items-center gap-2 p-2 border rounded-md hover:bg-blue-500 hover:text-white"
//                 >
//                   {/* <FaEdit /> Edit Booking Details */}
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <table>
//                   <tr>
//                     <td className="font-bold w-24">Booking Date </td>

//                     <td>
//                       {detailsdata?.appointment_starttime}
//                       {detailsdata?.appointment_start_time}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold">Service</td>
//                     <td>{detailsdata?.service_title}</td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold">Methods</td>
//                     <td>{detailsdata?.method_title}</td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold">Units</td>
//                     <td>{detailsdata?.unit_title}</td>
//                   </tr>{" "}
//                   <tr>
//                     <td className="font-bold">Addons</td>
//                     <td>{detailsdata?.addons_title}</td>
//                   </tr>{" "}
//                   <tr>
//                     <td className="font-bold">Price</td>
//                     <td>{detailsdata?.booking_price}</td>
//                   </tr>{" "}
//                   <tr>
//                     <td className="font-bold">Duration</td>
//                     <td>{detailsdata?.booking_duration}</td>
//                   </tr>
//                 </table>
//               </div>
//               <div className="flex justify-between">
//                 <h2 className="text-xl font-bold">Customer Detail</h2>
//                 <Link to={`editCustomer/${selectedEvent.client_id}`}>
//                   <button className="text-blue-500 mt-2 sm:mt-0">
//                     <span className="text-2xl">
//                       {/* <BiSolidEdit /> */}
//                     </span>
//                   </button>
//                 </Link>
//               </div>

//               {/* Customer Information */}
//               <div className="space-y-4">
//                 <table>
//                   <tr>
//                     <td className="font-bold w-20">Name</td>
//                     <td>{detailsdata?.client_name}</td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold ">Email </td>
//                     <td>{detailsdata?.client_email}</td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold ">Phone:</td>
//                     <td>{detailsdata?.client_phone}</td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold ">Notes:</td>
//                     <td>{detailsdata?.client_notes}</td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold">Address:</td>
//                     <td>
//                       <a
//                         href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//                           detailsdata?.client_address
//                         )}`}
//                         target="_blank"
//                         style={{ color: "blue" }}
//                         rel="noopener noreferrer"
//                       >
//                         {detailsdata?.client_address}
//                       </a>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="font-bold ">Payment:</td>
//                     <td>{detailsdata?.payment_type}</td>
//                   </tr>
//                 </table>
//               </div>
//               {/* Assign Appointment */}
//               <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
//                 <div className="flex items-center w-full sm:w-auto">
//                   <span className="mr-2">Assign Appointment to Staff:</span>
//                   <select
//                     className="border p-2 rounded-md w-full sm:w-auto"
//                     value={selectedStaff || ""}
//                     onChange={handleSelectChange}
//                   >
//                     <option value="">Nothing selected</option>
//                     {adminData && adminData.length > 0 ? (
//                       adminData.map((staff, index) => (
//                         <option key={index} value={staff.id}>
//                           {staff.fullname}
//                         </option>
//                       ))
//                     ) : (
//                       <option value="">No staff available</option>
//                     )}
//                   </select>
//                 </div>

//                 <div className="mt-2 sm:mt-0 sm:ml-4">
//                   <button className="text-blue-500" onClick={handleEditClick}>
//                     <span className="text-2xl">
//                       <BiSolidEdit />
//                     </span>
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
//               {detailsdata.booking_status === "R" && (
//                 <>
//                   <button
//                     type="button"
//                     onClick={() => handaldeleted(detailsdata.id)}
//                     className="text-red-500 font-semiboldpx-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     ✖ Delete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     🗑️ Delete All Recurring
//                   </button>
//                 </>
//               )}

//               {detailsdata.booking_status === "A" && (
//                 <>
//                   <button
//                     type="button"
//                     onClick={() => handalconfirm_appointment(detailsdata.id)}
//                     className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                   >
//                     ✔ confirm
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => handleRescheduleClick(detailsdata.id)}
//                     className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                   >
//                     ↻ Reschedule
//                   </button>

//                   <button
//                     type="button"
//                     onClick={handleRejectClick}
//                     className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     👎🏻 Reject
//                   </button>

//                   {/* Reschedule Modal */}
//                   {detailsdata && showRescheduleModal && (
//                     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                       <div className="bg-white p-6 rounded-md shadow-lg w-96">
//                         <h2 className="text-lg font-semibold mb-4">
//                           Reschedule Appointment
//                         </h2>
//                         {/* Amount Input */}
//                         <div className="mb-4">
//                           <label
//                             htmlFor="amount"
//                             className="block text-gray-700 mb-2"
//                           >
//                             Amount:
//                           </label>
//                           <input
//                             type="number"
//                             id="amount"
//                             value={
//                               detailsdata?.booking_price
//                                 ? detailsdata.booking_price.replace(
//                                     /[^0-9.-]+/g,
//                                     ""
//                                   )
//                                 : ""
//                             }
//                             className="w-full px-3 py-2 border rounded-md"
//                           />
//                         </div>

//                         {/* Date Picker (Calendar) */}
//                         <div className="mb-4">
//                           <label
//                             htmlFor="date"
//                             className="block text-gray-700 mb-2"
//                           >
//                             Select Date:
//                           </label>
//                           <input
//                             type="datetime-local"
//                             id="date"
//                             value={rescheduleDate}
//                             onChange={(e) => setRescheduleDate(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md"
//                           />
//                         </div>

//                         {/* Notes Input */}
//                         <div className="mb-4">
//                           <label
//                             htmlFor="notes"
//                             className="block text-gray-700 mb-2"
//                           >
//                             Notes:
//                           </label>
//                           <textarea
//                             id="notes"
//                             value={notes}
//                             onChange={(e) => setNotes(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md"
//                             placeholder="Add any notes"
//                           />
//                         </div>

//                         {/* Action Buttons */}
//                         <div className="flex justify-end gap-4">
//                           <button
//                             type="button"
//                             onClick={closeRescheduleModal}
//                             className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                           >
//                             Cancel
//                           </button>
//                           <button
//                             type="submit"
//                             onClick={(e) => handleUpdate(e, rescheduleDate)}
//                             className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                           >
//                             Update
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                   {/* Reject Form */}
//                   {showForm && (
//                     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                       <form
//                         onSubmit={(e) => handleReject(detailsdata.id, e)}
//                         className="bg-white p-6 rounded-md shadow-lg w-96"
//                       >
//                         <h2 className="text-lg font-semibold mb-4">
//                           Enter Reject Reason
//                         </h2>
//                         <label
//                           htmlFor="rejectReason"
//                           className="block text-gray-700 mb-2"
//                         >
//                           Reason:
//                         </label>
//                         <input
//                           type="text"
//                           id="rejectReason"
//                           value={rejectReason}
//                           onChange={(e) => setRejectReason(e.target.value)}
//                           className="w-full px-3 py-2 border rounded-md mb-4"
//                           placeholder="Reason for rejection"
//                         />
//                         <div className="flex justify-end gap-4">
//                           <button
//                             type="button"
//                             onClick={() => setShowForm(false)}
//                             className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                           >
//                             Cancel
//                           </button>
//                           <button
//                             type="submit"
//                             className="bg-red-500 text-white px-4 py-2 rounded-md"
//                           >
//                             Submit
//                           </button>
//                         </div>
//                       </form>
//                     </div>
//                   )}

//                   <button
//                     type="button"
//                     onClick={() => handaldeleted(detailsdata.id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     ✖ Delete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     🗑️ Delete All Recurring
//                   </button>
//                 </>
//               )}

//               {detailsdata.booking_status === "C" && (
//                 <>
//                   <button
//                     type="button"
//                     onClick={() => handalapointment_complete(detailsdata.id)}
//                     className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                   >
//                     ✔ Complete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => handaldeleted(detailsdata.id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     ✖ Delete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     🗑️ Delete All Recurring
//                   </button>
//                 </>
//               )}
//               {detailsdata.booking_status === "RS" && (
//                 <>
//                     <button
//                     type="button"
//                     onClick={() => handalapointment_complete(detailsdata.id)}
//                     className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                   >

//                     👍 Complete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => handleRescheduleClick(detailsdata.id)}
//                     className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                   >
//                    ↻ Reschedule
//                   </button>

//                   <button
//                     type="button"
//                     onClick={handleRejectClick}
//                     className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                   👎🏻 Reject
//                   </button>

//                   {/* Reschedule Modal */}
//                   {detailsdata && showRescheduleModal && (
//                     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                       <div className="bg-white p-6 rounded-md shadow-lg w-96">
//                         <h2 className="text-lg font-semibold mb-4">Reschedule Appointment</h2>
//                         {/* Amount Input */}
//                         <div className="mb-4">
//                           <label htmlFor="amount" className="block text-gray-700 mb-2">
//                             Amount:
//                           </label>
//                           <input
//                             type="number"
//                             id="amount"
//                             value={detailsdata?.booking_price ? detailsdata.booking_price.replace(/[^0-9.-]+/g, "") : ""}
//                             className="w-full px-3 py-2 border rounded-md"
//                           />
//                         </div>

//                         {/* Date Picker (Calendar) */}
//                         <div className="mb-4">
//                           <label htmlFor="date" className="block text-gray-700 mb-2">
//                             Select Date:
//                           </label>
//                           <input
//                             type="datetime-local"
//                             id="date"
//                             value={rescheduleDate}
//                             onChange={(e) => setRescheduleDate(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md"
//                           />
//                         </div>

//                         {/* Notes Input */}
//                         <div className="mb-4">
//                           <label htmlFor="notes" className="block text-gray-700 mb-2">
//                             Notes:
//                           </label>
//                           <textarea
//                             id="notes"
//                             value={notes}
//                             onChange={(e) => setNotes(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md"
//                             placeholder="Add any notes"
//                           />
//                         </div>

//                         {/* Action Buttons */}
//                         <div className="flex justify-end gap-4">
//                           <button
//                             type="button"
//                             onClick={closeRescheduleModal}
//                             className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                           >
//                             Cancel
//                           </button>
//                           <button
//                             type="submit"
//                             onClick={(e) => handleUpdate(e, rescheduleDate)}
//                             className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                           >
//                             Update
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                   {/* Reject Form */}
//                   {showForm && (
//                     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                       <form onSubmit={(e) => handleReject(detailsdata.id, e)} className="bg-white p-6 rounded-md shadow-lg w-96">
//                         <h2 className="text-lg font-semibold mb-4">Enter Reject Reason</h2>
//                         <label htmlFor="rejectReason" className="block text-gray-700 mb-2">
//                           Reason:
//                         </label>
//                         <input
//                           type="text"
//                           id="rejectReason"
//                           value={rejectReason}
//                           onChange={(e) => setRejectReason(e.target.value)}
//                           className="w-full px-3 py-2 border rounded-md mb-4"
//                           placeholder="Reason for rejection"
//                         />
//                         <div className="flex justify-end gap-4">
//                           <button
//                             type="button"
//                             onClick={() => setShowForm(false)}
//                             className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                           >
//                             Cancel
//                           </button>
//                           <button type="submit" className="bg-red-500 text-white px-4 py-2 rounded-md">
//                             Submit
//                           </button>
//                         </div>
//                       </form>
//                     </div>
//                   )}

//                   <button
//                     type="button"
//                     onClick={() => handaldeleted(detailsdata.id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                    ✖ Delete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                    🗑️ Delete All Recurring
//                   </button>
//                 </>
//               )}

//               {detailsdata.booking_status === "CO" && (
//                 <>
//                   <div className="text-gray-500">
//                     This Appointment Is Completed
//                   </div>

//                   <button
//                     type="button"
//                     onClick={() => handaldeleted(detailsdata.id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     ✖ Delete
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => deleteallbooking(detailsdata.recurring_id)}
//                     className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                   >
//                     🗑️ Delete All Recurring
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//         {/* Sidebar */}
//         {notificationSidebarVisible && (
//           <div
//         ref={sidebarRef}
//           className="fixed top-0 right-0 w-80 bg-white text-black p-6 shadow-lg border-l-4 border-blue-800 z-50 transition-all duration-300 max-h-screen overflow-y-auto">
//             {/* Close Button */}
//             <button

//               onClick={() => setNotificationSidebarVisible(false)}
//               className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//             >
//               <FiX />
//             </button>

//             {/* Sidebar Title */}
//             <h2 className="text-2xl font-medium mb-4">Booking Information</h2>

//             {/* Search Input */}
//             <input
//                 type="text"
//                 placeholder="Search by name..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-md focus:shadow-lg transition-shadow"
//               />

//             {/* Filtered Booking List */}
//             {filteredBookings.length > 0 ? (
//               filteredBookings.map((booking, index) => {
//                 const bookingDate = new Date(booking.booking_date_time);
//                 const today = new Date();

//                 // Normalize today's date (remove time for accurate comparison)
//                 today.setHours(0, 0, 0, 0);
//                 bookingDate.setHours(0, 0, 0, 0);

//                 const timeDiff = bookingDate - today;
//                 const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

//                 // Calculate remaining time (days or months)
//                 let timeText;
//                 if (daysDiff === 0) {
//                   timeText = "Today";
//                 } else if (daysDiff >= 30) {
//                   const months = Math.floor(daysDiff / 30); // Only full months
//                   timeText = `${months} ${months > 1 ? "months" : "month"}`;
//                 } else {
//                   timeText = `${daysDiff} ${daysDiff > 1 ? "days" : "day"}`;
//                 }
//                 // Status mapping
//                 const statusLabels = {
//                   A: "Confirmed",
//                   C: "Cancelled",
//                   R: "Rejected",
//                   CC: "Customer Cancelled",
//                   CS: "Customer Service",
//                   CO: "Completed",
//                   MC: "Manager Confirmed",
//                   RS: "Rescheduled",
//                 };

//                 return (
//                   <div
//                   key={index}
//                   className="mb-4 p-4 border rounded-lg shadow-md bg-gray-100 transition-all duration-300 transform hover:shadow-xl hover:scale-[1.02]"
//                 >
//                   <p className="text-lg text-gray-700">
//                     {booking.clientName} for {booking.title} on{" "}
//                     <strong>{bookingDate.toLocaleDateString()}</strong> {/* Only Date */}
//                   </p>

//                   {/* Show remaining or late days in proper format */}
//                   <p
//                     className={`font-medium ${
//                       daysDiff < 0 ? "text-red-500" : "text-blue-500"
//                     }`}
//                   >
//                     {daysDiff < 0 ? `${Math.abs(daysDiff)} days late` : `${timeText} remaining`}
//                   </p>

//                   <button
//                     className={`px-4 py-2 rounded-lg transition-all duration-300 transform hover:scale-110 ${
//                       booking.booking_status === "A"
//                         ? "bg-green-500 text-white"
//                         : booking.booking_status === "C" ||
//                           booking.booking_status === "R" ||
//                           booking.booking_status === "CC"
//                         ? "bg-red-500 text-white"
//                         : booking.booking_status === "CO"
//                         ? "bg-blue-500 text-white"
//                         : "bg-yellow-500 text-white"
//                     }`}
//                     onClick={() => handleShowModal(booking)}
//                   >
//                     {statusLabels[booking.booking_status] || "Unknown"}
//                   </button>
//                 </div>

//                 );
//               })
//             ) : (
//               <p className="text-gray-500">No bookings found</p>
//             )}
//           </div>
//         )}
//         {/* Content Section */}
//         <main className=" flex-1 p-8">
//           <Outlet /> {/* This renders the matching route content */}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminPanel;

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FiMenu, FiChevronRight, FiPlus, FiList, FiX } from "react-icons/fi"; // Import hamburger and right-chevron icon
// import { Outlet } from "react-router-dom";
// import { FaBell, FaUser } from 'react-icons/fa';
// import { FaPowerOff } from "react-icons/fa6";
// import { MdOutlinePayment } from "react-icons/md";
// import {  IoBook } from "react-icons/io5";
// import { HiEye } from "react-icons/hi2";
// import { MdEmail,MdSms, MdLabel  } from "react-icons/md";
// import { BsFileCodeFill } from "react-icons/bs";
// import { IoIosSettings } from "react-icons/io";
// import { FaCode } from "react-icons/fa";
// // Import GIFs from your assets folder
// import appointmentGif from "../assets/appointment.gif";
// import serviceGif from "../assets/service.gif";
// import scheduleGif from "../assets/schedule.gif";
// import staffGif from "../assets/staff.gif";
// import crmGif from "../assets/crm.gif";
// import paymentGif from "../assets/payment.gif";
// import exportGif from "../assets/export.gif";
// import settingsGif from "../assets/settings.gif";
// import embedGif from "../assets/embeded.gif";

// const AdminPanel = () => {
//   const navigate = useNavigate(); // Initialize navigate hook
//   const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar starts as hidden
//   const [notificationSidebarVisible, setNotificationSidebarVisible] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [submenuVisible, setSubmenuVisible] = useState({
//     appointment: false,
//     service: false,
//     schedule: false,
//     staff: false,
//     crm: false,
//     payment: false,
//     export: false,
//     embeded: false,
//     setting: false,
//   }); // State for submenu visibility

//   // Function to handle navigation
//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   // Toggle Sidebar visibility
//   const toggleSidebar = () => {
//     setSidebarVisible(!sidebarVisible);
//   };

//   // Toggle Notification Sidebar visibility
//   const toggleNotificationSidebar = () => {
//     setNotificationSidebarVisible(!notificationSidebarVisible);
//   }

//   // Toggle submenu visibility for each section
//   const toggleSubmenu = (section) => {
//     setSubmenuVisible((prevState) => ({
//       ...prevState,
//       [section]: !prevState[section],
//     }));
//   };

//   const handleProfileClick = () => {
//     // Navigate to the admin profile page
//     navigate("adminProfile");
//   };

//   const handleLogoutClick = () => {
//     // Show the confirmation modal when logout icon is clicked
//     setShowLogoutModal(true);
//   };

//   const handleLogoutConfirm = () => {
//     // Navigate to the login page when user confirms logout
//     setShowLogoutModal(false); // Close modal
//     navigate("/"); // Redirect to login page
//   };

//   const handleLogoutCancel = () => {
//     // Close the modal without logging out
//     setShowLogoutModal(false);
//   };

//   return (
//     <div className="flex min-h-screen">
//       {/* Sidebar */}
//       <div
//         className={`${
//           sidebarVisible ? "block" : "hidden"
//         } fixed top-0 left-0 w-64 h-full bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 rounded-lg z-50 transition-all duration-300`}
//         style={{ maxHeight: "100vh", overflowY: "auto" }} // Allow scrolling within the sidebar
//       >
//         {/* Close Icon */}
//         <button
//           onClick={() => setSidebarVisible(false)}
//           className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//         >
//           <FiX />
//         </button>
//         <h2 className="text-2xl font-medium text-center mb-8">Cleanto</h2>
//         <ul>
//           {/* Appointment Section */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/appointment")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={appointmentGif}
//                   alt="Appointment"
//                   className="w-12 h-12 object-contain transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Appointment</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("appointment")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.appointment ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Submenu for Appointment */}
//             {/* {submenuVisible.appointment && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/appointments/create")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Create Appointment
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/appointments/manage")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Manage Appointment
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Service */}

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/service")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={serviceGif}
//                   alt="Service"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Service</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("service")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.service ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Service Submenu */}
//             {/* {submenuVisible.service && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/service/create")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-black text-left transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 text-lg" />
//                     <span className="text-left">Add Service</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/service/manage")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left">Manage Services</span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Repeat the above structure for other sections: schedule, staff, crm, payment, export, settings */}

//           {/* Schedule */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/schedule")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={scheduleGif}
//                   alt="Schedule"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Schedule</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("schedule")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.schedule ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Schedule Submenu */}
//             {/* {submenuVisible.schedule && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/create")}
//                     className="block text-gray-700 hover:bg-blue-200 p-2 rounded-md"
//                   >
//                     Create Schedule
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/manage")}
//                     className="block text-gray-700 hover:bg-blue-200 p-2 rounded-md"
//                   >
//                     Manage Schedule
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           {/* Additional menu items (Staff, CRM, Payment, Export, Settings) would follow a similar structure */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/staff")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={staffGif}
//                   alt="Staff"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Staff</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("staff")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.staff ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Staff Submenu */}
//             {submenuVisible.staff && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/staff/addStaff")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Staff Details</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/staff/staffPayment")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Staff Payment Details
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//           {/* {crm} */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/crm")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={crmGif}
//                   alt="CRM"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">CRM</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("crm")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.crm ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* CRM Submenu */}
//             {submenuVisible.crm && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/crm/guestcustomer")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Guest Customer</span>
//                   </button>
//                 </li>

//               </ul>
//             )}
//           </li>

//           {/* Payment */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/payment")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={paymentGif}
//                   alt="Payment"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Payment</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("payment")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.payment ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.payment && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/payment/staffPaymentDetails")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Staff Payment Details
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/payment/recurrenceDetail")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Recurrence Details
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/export")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={exportGif}
//                   alt="export"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Export</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("export")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.export ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.export && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/export/customerInformation")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Customer Information
//                     </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/export/serviceInformation")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       Service Information
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/embeded")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={embedGif}
//                   alt="embeded"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Embed Code</span>
//               </div>
//               {/* <FiChevronRight
//                 onClick={() => toggleSubmenu("embeded")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.embeded ? "rotate-90" : "rotate-0"
//                 }`}
//               /> */}
//             </button>
//             {/* Schedule Submenu */}
//             {/* {submenuVisible.embeded && (
//               <ul className="pl-8">
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/create")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiPlus className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">Create </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/schedule/manage")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FiList className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Manage Schedule{" "}
//                     </span>
//                   </button>
//                 </li>
//               </ul>
//             )} */}
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/admin/setting")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={settingsGif}
//                   alt="setting"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Setting</span>
//               </div>
//               <FiChevronRight
//                 onClick={() => toggleSubmenu("setting")}
//                 className={`transition-transform duration-300 transform ${
//                   submenuVisible.setting ? "rotate-90" : "rotate-0"
//                 }`}
//               />
//             </button>
//             {/* Schedule Submenu */}
//             {submenuVisible.setting && (
//               <ul className="pl-16">
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/appearance")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <HiEye className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold "> Appearance</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/genral")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <IoIosSettings className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> General</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/payment")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdOutlinePayment className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Payment </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/promocode")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <BsFileCodeFill className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Promocode </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/smsTemplate")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdSms className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> SMS Template</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/referral")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <FaCode className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Referral</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/seo")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     SEO
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/quickbook")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <IoBook className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Quick Book </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/emailNotification")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdEmail className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Email No</span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/label")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdLabel className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> Labels </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/emailTemplate")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Email Template
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/fronttooltip")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Front Tool Tips
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/smsnotification")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdSms className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold"> SMS Not </span>
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/manageableForm")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     <MdSms className="text-2xl text-gray-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105" />
//                     <span className="text-left font-bold">
//                       {" "}
//                       Manageable Form Fields{" "}
//                     </span>
//                   </button>
//                 </li>

//                 <li>
//                   <button
//                     onClick={() =>
//                       handleNavigation("/admin/setting/recurrence")
//                     }
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Recurrence
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => handleNavigation("/admin/setting/xero")}
//                     className="flex items-center space-x-3 text-gray-700 hover:bg-blue-200 p-2 rounded-md w-full"
//                   >
//                     Xero
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </li>
//         </ul>
//       </div>

//       {/* Main Layout */}
//       <div className="flex-1 flex flex-col relative">
//         {/* Header */}
//         <header className="bg-blue-800 text-white p-4 flex justify-between items-center">
//           <button onClick={toggleSidebar} className="text-white text-2xl">
//             <FiMenu />
//           </button>
//           <h1
//             onClick={() => navigate("/my-booking")}
//             className="text-2xl font-medium cursor-pointer"
//           >
//             My Booking Page
//           </h1>
//           <div className="flex items-center space-x-4">
//             {/* Notification Icon */}
//             <button onClick={toggleNotificationSidebar} className="text-white">
//               <FaBell size={24} />
//             </button>

//             {/* Profile Icon */}
//             <button onClick={handleProfileClick} className="text-white">
//               <FaUser size={24} />
//             </button>

//             {/* Logout Icon */}
//             <button onClick={handleLogoutClick} className="text-white">
//               <FaPowerOff size={24} />
//             </button>
//           </div>
//         </header>

//         {/* Logout Modal */}
//         {showLogoutModal && (
//           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 sm:w-1/3 max-w-sm">
//               <p className="text-lg font-medium text-gray-800 mb-4">
//                 Are you sure you want to log out?
//               </p>
//               <div className="flex justify-center space-x-4 mt-4">
//                 <button
//                   onClick={handleLogoutConfirm}
//                   className="px-4 py-2 bg-green-500 text-white rounded-md"
//                 >
//                   Yes
//                 </button>
//                 <button
//                   onClick={handleLogoutCancel}
//                   className="px-4 py-2 bg-red-500 text-white rounded-md"
//                 >
//                   No
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {/* Sidebar */}
//         {notificationSidebarVisible && (
//           <div className="fixed top-0 right-0 w-80 bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 z-50 transition-all duration-300">
//             <button
//               onClick={() => setNotificationSidebarVisible(false)}
//               className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//             >
//               <FiX />
//             </button>
//             <h2 className="text-2xl font-medium mb-4">Booking Information</h2>
//             <p className="text-lg text-gray-700 mb-6">
//               John Doe for a house cleaning on 08-Dec-2024 01:00 PM 2day
//             </p>
//             <button className="bg-green-500 text-white px-4 py-2 rounded-lg">
//               Confirmed
//             </button>
//           </div>
//         )}

//         {/* Content Section */}
//         <main className=" flex-1 p-8">
//           <Outlet /> {/* This renders the matching route content */}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminPanel;

// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaCalendarAlt, FaCogs, FaUsers, FaCreditCard, FaClipboardList, FaDownload } from "react-icons/fa"; // Import icons

// const AdminPanel = () => {
//   const navigate = useNavigate(); // Initialize navigate hook

//   // Function to handle navigation
//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className="flex min-h-screen">
//       {/* Sidebar */}
//       <div className="w-64 bg-blue-600 text-white p-6">
//         <h2 className="text-3xl font-bold mb-8">Cleanto</h2>
//         <ul>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaCalendarAlt className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Appointment</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/service")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaClipboardList className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Service</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/schedule")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaCalendarAlt className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Schedule</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/staff")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaUsers className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Staff</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/crm")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaCogs className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">CRM</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/payment")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaCreditCard className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Payment</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/export")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaDownload className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Export</span>
//             </button>
//           </li>
//           <li className="mb-6">
//             <button
//               onClick={() => handleNavigation("/admin/settings")}
//               className="flex items-center space-x-4 text-white hover:text-orange-400 transition-all duration-300"
//             >
//               <FaCogs className="text-3xl transition-all duration-300 transform hover:scale-110 hover:rotate-180" />
//               <span className="text-xl">Settings</span>
//             </button>
//           </li>
//         </ul>
//       </div>

//       {/* Main content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <header className="bg-white text-black shadow-md p-4 flex justify-between items-center">
//           <h1 className="text-2xl font-bold">Admin Panel</h1>
//           <div className="flex items-center">
//             <button
//               onClick={() => handleNavigation("/admin/settings")}
//               className="text-black hover:text-orange-400"
//             >
//               Settings
//             </button>
//             <button className="bg-orange-500 text-white px-4 py-2 rounded-lg ml-4">
//               Logout
//             </button>
//           </div>
//         </header>

//         {/* Content Section */}
//         <main className="flex-1 p-8">
//           <h2 className="text-3xl font-bold">Welcome to the Admin Panel</h2>
//           {/* You can add more content here */}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminPanel;
